(function (angular) {
    angular
        .module('one.admin.config')
        .config(config);

    config.$inject = ['$translateProvider'];

    function config($translateProvider) {
        $translateProvider.translations('en', {
            general: {
                'account_settings': 'My account',
                'add_account': 'Add contact',
                'add_contact': 'Add person',
                'add_organisation': 'Add organisation',
                'add_bank_account': 'Add bank account',
                'add_interaction': 'Add interaction',
                'add_interaction_subject': 'Add interaction subject',
                'add_discount_code': 'Add discount code',
                'add_group': 'Add group',
                'add_form_entry': 'Add form entry',
                'add_form_page': 'Add form page',
                'add_campaign': 'Add campaign',
                'add_mailing': 'Add mailing',
                'add_mail_sender': 'Add mail sender',
                'add_mail_template': 'Add mail template',
                'add_member': 'Add member',
                'add_module': 'Add content',
                'add_page': 'Add page',
                'add_page_block': 'Add page block',
                'add_page_nav': 'Add navigation',
                'add_page_nav_link': 'Add item',
                'add_child_page_nav_link': 'Add sub item',
                'add_action_campaign_overview_module': 'Add campaign overview',
                'add_content_module': 'Add content block',
                'add_html_module': 'Add HTML block',
                'add_faq_module': 'Add FAQ',
                'add_faq_subsection': 'Add Q&A',
                'add_form_module': 'Add form',
                'add_term': 'Add term',
                'add_post': 'Add post',
                'add_product': 'Add product',
                'add_product_category': 'Add product category',
                'add_products': 'Add products',
                'add_segment': 'Add segment',
                'add_order': 'Add order',
                'add_relation': 'Add relation',
                'add_sdd_batch': 'Add direct debit batch',
                'add_sdd_reversal_batch': 'Add reversal batch',
                'add_purchase': 'Add purchase',
                'add_transactional_mail': 'Add transactional mail',
                'add_team': 'Add team',
                'add_news_module': 'Add news module',
                'add_news_feed_module': 'Add news feed module',
                'add_video_module': 'Add video',
                'add_action_project': 'Add project',
                'add_action_campaign': 'Add campaign',
                'add_form': 'Add form',
                'add_field': 'Add field',
                'add_tag': 'Add tag',
                'add_list_module': 'Add list',
                'add_card_module': 'Add card',
                'add_carousel_module': 'Add carousel',
                'add_slider_module': 'Add slider',
                'add_image_module': 'Add image',
                'add_line_module': 'Add line',
                'add_button_module': 'Add button',
                'add_countdown_module': 'Add countdown',
                'add_gallery_module': 'Add gallery',
                'add_share_module': 'Add share module',
                'add_event': 'Add event',
                'add_ticket': 'Add ticket',
                'edit_contact': 'Edit contact',
                'edit_organisation': 'Edit organisation',
                'edit_bank_account': 'Edit bank account',
                'edit_interaction': 'Edit interaction',
                'edit_discount_code': 'Edit discount code',
                'edit_group': 'Edit group',
                'edit_form_entry': 'Edit form entry',
                'edit_form_page': 'Edit form page',
                'edit_form': 'Edit form',
                'edit_campaign': 'Edit campaign',
                'edit_mailing': 'Edit mailing',
                'edit_mail_sender': 'Edit mail sender',
                'edit_mail_template': 'Edit mail template',
                'edit_member': 'Edit member',
                'edit_page': 'Edit page',
                'edit_page_block': 'Edit page block',
                'edit_page_nav': 'Edit navigation',
                'edit_action_campaign_overview_module': 'Edit campaign overview',
                'edit_content_module': 'Edit content block',
                'edit_html_module': 'Edit HTML block',
                'edit_faq_module': 'Edit FAQ block',
                'edit_form_module': 'Edit form',
                'edit_post': 'Edit post',
                'edit_video_module': 'Edit video',
                'edit_news_feed_module': 'Edit news feed',
                'edit_term': 'Edit term',
                'edit_product': 'Edit product',
                'edit_product_category': 'Edit product category',
                'edit_segment': 'Edit segment',
                'all_recipients': 'All recipients',
                'single_recipient': 'Single recipient',
                'single_recipient_description': 'Send the mailing to a single contact.',
                'edit_order': 'Configure order',
                'edit_contact_details': 'Edit contact details',
                'edit_organisation_details': 'Edit organisation details',
                'edit_personal_info': 'Edit personal information',
                'edit_organisation_info': 'Edit organisation information',
                'edit_purchase': 'Edit purchase',
                'edit_transaction': 'Edit transaction',
                'edit_transactional_mail': 'Edit transactional mail',
                'edit_team': 'Edit team',
                'edit_news_module': 'Edit news module',
                'edit_contact_person': 'Edit contact person',
                'edit_action_project': 'Edit project',
                'edit_action_campaign': 'Edit campaign',
                'edit_gift': 'Edit gift',
                'add_gift_reward': 'Add gift reward',
                'edit_gift_reward': 'Edit gift reward',
                'edit_form': 'Edit form',
                'edit_field': 'Edit field',
                'edit_list_module': 'Edit list',
                'edit_card_module': 'Edit card',
                'edit_carousel_module': 'Edit carousel',
                'edit_slider_module': 'Edit slider',
                'edit_image_module': 'Edit image',
                'edit_line_module': 'Edit line',
                'edit_button_module': 'Edit button',
                'edit_countdown_module': 'Edit countdown',
                'edit_gallery_module': 'Edit gallery',
                'edit_share_module': 'Edit share module',
                'edit_event': 'Edit event',
                'edit_tag': 'Edit tag',

                'action_campaign_overview_module': 'Campaign overview',
                'content_module': 'Content block',
                'html_module': 'HTML block',
                'faq_module': 'FAQ block',
                'form_module': 'Form module',
                'post': 'Post',
                'video_module': 'Video',
                'news_feed_module': 'News feed',
                'news_module': 'News',
                'list_module': 'List',
                'card_module': 'Card',
                'carousel_module': 'Carousel',
                'image_module': 'Image',
                'line_module': 'Line',
                'button_module': 'Button',
                'countdown_module': 'Countdown',
                'gallery_module': 'Gallery',
                'share_module': 'Share',

                'internal': 'Internal',
                'no_internet': '🤖 You are offline.',
                'maintenance': '🤓 One Community is being updated. Be right back.',
                'update_available': '🎂 Update available',
                'click_to_refresh': 'Refresh now',
                'by': 'by',
                'oops': 'Oops',
                'authorisation': 'Authorisation',
                'authentication': 'Authentication',
                'impersonate': 'Impersonate',
                'security': 'Security',
                'anywhere': 'Anywhere',

                'any': 'Any',
                'all': 'All',
                'operator': 'Operator',
                'value': 'Value',
                'no_value': 'No value',
                'condition': 'Condition',
                'new': 'New',
                'new_dots': 'New...',
                'inc.': 'Inc.',
                'ex.': 'Ex.',
                'included': 'Included',
                'excluded': 'Excluded',
                'base_amount': 'Base amount',
                'original_amount': 'Original amount',
                'original_net_amount': 'Original net amount',
                'original_gross_amount': 'Original gross amount',
                'net_amount': 'Net amount',
                'gross_amount': 'Gross amount',
                'vat_amount': 'VAT amount',
                'vat_percentage': 'VAT percentage',
                'vat_percentages': 'VAT percentages',
                'received_amount': 'Received amount',
                'purchased_amount': 'Purchased amount',
                'id': 'ID',
                'more_options': 'More options',
                'fewer_options': 'Fewer options',
                'or': 'or',
                'or_create': 'or create',
                'enter_text': 'Enter text...',
                'enter_title': 'Enter a title',
                'html': 'HTML',
                'css': 'CSS',
                'styles': 'Styles',
                'sass_variables': 'SASS variables',
                'gift_product': 'Gift product',
                'gift_product_description': 'Purchases of gifts to this project or associated action campaigns will get this product.',
                'gift': 'Gift',
                'gifts': 'Gifts',
                'gifted_to': 'Gifted to',
                'gift_to': 'Gift to',
                'gift_desc': 'Purchases are gifted to some contact.',
                'gift_reward': 'Gift reward',
                'gift_rewards': 'Gift rewards',
                'gift_reward_amount_description': 'The minimum donation amount for this reward.',
                'gift_reward_quantity_description': 'Set a quantity if availability of this reward is limited. Otherwise, leave empty.',
                'gift_reward_product_description': 'If you set a product, it will be added to the order when a donation is made. The product amount will be subtracted from the donation amount.',
                'gift_reward_group_description': 'Set a group so that this gift reward will only show up on a crowdfunding page if the campaigner is a member of this group.',
                'gift_reward_page_description': 'Optionally, set a page that contains the donation form where this gift reward can be selected. The gift reward will be hidden in other donation forms.',
                'read_more_in_kb_article': 'Read more in the <a href="{{ url }}" target="_blank" rel="noopener">Knowledge Base <i class="md-icon">open_in_new</i></a> article.',
                'annual_amount': 'Annual amount',
                'annual_payments': 'Annual payments',
                'save_annual_payment': 'Save annual payment',
                'contributes_to_annual_amount': 'Contributes to annual amount',
                'annual_amount_desc': 'Purchases contribute to the yearly expected and actual amount of a contact.',
                'actual': 'Actual',
                'expected': 'Expected',
                'ratio': 'Ratio',
                'personal_message': 'Personal message',
                'privacy_settings': 'Privacy settings',
                'privacy': 'Privacy',
                'dont_share_contact_info': 'Do not share contact info',
                'share_contact_info': 'Share contact info',
                'hide_name': 'Hide name',
                'hide_amount': ' Hide amount',
                'team_amount': 'Team fundraising',
                'share_in_team_amount': 'Share in funds raised by the team',
                'share_in_team_gifts': 'Share in team gifts',
                'button_content_description': 'The text that will be shown in the button.',
                'show_in_search_engines': 'Show in search engines',
                'show_in_search_engines_description': 'Allow search engines such as Google to include this page in their search results.',

                'length': 'Length',
                'variables': 'Variables',
                'extra': 'Extra',
                'notifications': 'Notifications',

                'issuer': 'Issuer',
                'ideal_payment': 'iDEAL payment',
                'ideal_transaction_id': 'iDEAL reference',
                'adyen_payment': 'Adyen payment',
                'adyen_psp_reference': 'Adyen reference',
                'cm_payment': 'CM payment',
                'cm_transaction_id': 'CM reference',
                'mollie_payment': 'Mollie payment',
                'mollie_transaction_id': 'Mollie reference',
                'buckaroo_payment': 'Buckaroo payment',
                'buckaroo_transaction_id': 'Buckaroo reference',
                'tikkie_payment': 'Tikkie payment',
                'tikkie_payment_token': 'Tikkie reference',
                'no_email_address': 'No email address',

                'app_title': 'emolife One Community',
                'enable': 'Enable',
                'disable': 'Disable',
                'enabled': 'Enabled',
                'disabled': 'Disabled',
                'enable_gift_reward': 'Enable gift reward',
                'enable_two_factor_authentication': 'Enable two-factor authentication',
                'two_factor_authentication': 'Two-factor authentication',
                '2fa': '2FA',
                'two_factor_authentication_description': 'We have sent an SMS to {{ phone_number }} to verify your identity.',
                'authy_suggestion': 'Don\'t want to use SMS? Try the <a href="https://authy.com/download/" target="_blank" rel="noopener">Authy app <i class="md-icon">open_in_new</i></a>.',
                'success_page': 'Success page',
                'success_visitable': 'Success page',
                'new_account': 'New contact',
                'new_contact': 'New person',
                'new_organisation': 'New organisation',
                'new_team': 'New team',

                'delete_account': 'Delete contact',
                'delete_account_description': 'Remove the contact from the CRM &ndash; including groups, segments and mailings. The contact\'s orders will be cancelled and the financial transactions will remain visible in One Community. <strong>This action is irreversible.</strong>',
                'delete_account_confirmation_string': 'DELETE',
                'delete_account_confirmation_description': 'Type <em>{{ \'general.delete_account_confirmation_string\' | translate }}</em> in the field below to confirm.',
                'cancel_account_orders': 'Cancel all orders linked to this contact',
                'refund_account_orders': 'Also refund all payments',
                'purchase_start_date_in_past': 'Start date cannot be in the past.',
                'confirmation': 'Confirmation',
                'send_mail': 'Send mail',
                'compose': 'Compose',
                'compose_mail': 'Compose mail',
                'email_required_for_mail': 'There is no email address associated with this contact. To send an email to this contact, please continue and enter an email address.',
                'email_required_for_interaction_notification': 'To send a notification email to this contact, add an email address first.',
                'enter_email': 'Enter email address',
                'mail': 'Mail',
                'create_segment': 'Create segment',
                'add_segment': 'Add segment',
                'edit_recipients': 'Edit recipients',
                'subscription': 'Subscription',
                'do_not_mail': 'Unsubscribe from all mailings',
                'unsubscribed_from_mailings': 'Unsubscribed from mailings',
                'unsubscribed_from_mails': 'Unsubscribed from mailings',
                'unsubscribed': 'Unsubscribed',
                'date_unsubscribed_from_mails': 'Date unsubscribed from mailings',
                'optins': 'Opt-ins',
                'no_mail_permissions_yet': 'No permissions have been added yet.',
                'manage_mail_permissions': 'Manage mail permissions',
                'send_only_to_optins': 'Optionally, only send this mailing to recipients that have any of selected opt-ins. Leave empty to send this mailing to all recipients.',
                'email_optins_group_description': 'This is a special group that contains mail permissions for your mailings. Add a subgroup to create a new mail permission. Contacts that are in a subgroup are considered to have an opt-in and can be removed from that group to opt out.',
                'auto_login_links': 'Auto-login link{{ count != 1 ? "s" : "" }} detected',
                'retry': 'Retry',
                'times_used': 'Times used',
                'find_group': 'Find group',
                'select_existing_group': 'Select existing group',
                'new_action_project': 'New crowdfunding project',
                'select_existing_action_project': 'Select existing crowdfunding project',
                'add_to_group': 'Add to group',
                'new_group': 'New group',
                'external_identifiers': 'External identifiers',
                'make_selection': 'Make selection',
                'make_primary_organisation': 'Make primary organisation',
                'merge': 'Merge',
                'merge_dots': 'Merge...',
                'dots_into': '...into',
                'merge_accounts': 'Merge another contact into this contact',
                'merge_account_description': 'If you merge two contacts, all of the information of the duplicate contact will be added to the master contact. The duplicate contact will be deleted. This action is irreversible.',
                'merge_account_master_description': 'The master contact that you want to keep',
                'merge_account_duplicate_description': 'The duplicate contact which will be deleted after the merge',
                'swap_merge_direction': 'Change merge direction',
                'merge_with_account': 'Merge with contact',
                'merge_action_campaigns': 'Merge another campaign into this campaign',
                'merge_action_campaign_description': 'If you merge two campaigns, all of the information of the other campaign will be added to the master campaign, including participants, updates, and gifts. The other campaign will then be deleted. This action is irreversible.',
                'merge_action_campaign_master_description': 'The master campaign that you want to keep',
                'merge_action_campaign_duplicate_description': 'The other campaign which will be deleted after the merge',
                'view_account': 'View contact',
                'dump_database': 'Dump database',
                'checklist': 'Checklist',
                'check_cookies': 'Ask for cookie consent',
                'show_login': 'Show login button',
                'show_login_description': 'Disable to hide the login button from end-users.',
                'not_yet_finished': 'Not yet finished (to do)',
                'not_yet_finished': 'Mark as to-do',
                'task_completed': 'Task completed',
                'never': 'Never',

                // Auth & gateway
                'greeting': 'Hi, ',
                'select_project': 'Select a project',
                'switch_project': 'Switch project',
                'project': 'Project',
                'projects': 'Projects',
                'log_in': 'Log in',
                'log_out': 'Log out',
                'for_project': 'For project',
                'for_organisation': 'For organisation',

                // Management User
                'add_user': 'Add user',
                'edit_user': 'Edit user',
                'user': 'User',
                'users': 'Users',
                'user_info': 'User Info',
                'contact_users': 'Contact users',

                // Interactions
                'contact_date': 'Contact date',
                'contact_with': 'Contact with',
                'inactive_since': 'Inactive since',
                'via': 'Via',

                // Content
                'description': 'Description',
                'default_value': 'Default value',
                'min': 'Min',
                'max': 'Max',
                'required': 'Required',
                'choice': 'Choice',
                'choices': 'Choices',
                'file': 'File',
                'files': 'Files',
                'filename': 'Filename',
                'source': 'Source',
                'pages': 'Pages',
                'page': 'Page',
                'page_flag': 'Page flag',
                'page_block': 'Page block',
                'page_blocks': 'Page blocks',
                'navigation': 'Navigation',
                'header_and_footer': 'Header & footer',
                'form_page': 'Form page',
                'header': 'Header',
                'footer': 'Footer',
                'header_block': 'Header block',
                'footer_block': 'Footer block',
                'language': 'Language',
                'modules': 'Content',
                'module': 'Content',
                'existing_module': 'Select an existing module',
                'new_module': 'Or create a new module',
                'refresh': 'Refresh',
                'refreshing': 'Refreshing',
                'refreshed': 'Refreshed',
                'add': 'Add',
                'add_dots': 'Add...',
                'configure': 'Configure',
                'edit': 'Edit',
                'edit_details': 'Edit details',
                'delete': 'Delete',
                'enter': 'Enter',
                'select': 'Select',
                'upload': 'Upload',
                'browse': 'Browse',
                'select_accounts': 'Select accounts...',
                'select_groups': 'Select groups...',
                'select_segments': 'Select segments...',
                'select_sender': 'Select sender...',
                'loading': 'Loading...',
                'search': 'Search...',
                'search_term': 'Search Term',
                'website': 'Website',
                'site': 'Website',
                'site_name': 'Website name',
                'option': 'Option',
                'options': 'Options',
                'type': 'Type',
                'types': 'Types',
                'field_type': 'Field type',
                'visitable': 'Visitable',
                'logging_in': 'Logging in...',
                'label': 'Label',
                'labels': 'Labels',
                'content': 'Content',
                'email': 'E-mail',
                'email_address': 'E-mail address',
                'secondary_email': 'E-mail (secondary)',
                'email_primary': 'E-mail (primary)',
                'email_secondary': 'E-mail (secondary)',
                'username': 'Username',
                'primary': 'Primary',
                'secondary': 'Secondary',
                'change_password': 'Change password',
                'password': 'Password',
                'password_repeat': 'Password (repeat)',
                'current_password': 'Current password',
                'new_password': 'New password',
                'new_password_repeat': 'New password (repeat)',
                'remember_me': 'Remember me',
                'account_has_no_password': 'No password has been set.',
                'account_has_password': '{{ title }} has set a password.',
                'title': 'Title',
                'intro': 'Intro',
                'toggle': 'Toggle',
                'slide': 'Slide',
                'slides': 'Slides',
                'slider_image': 'Slider image',
                'slider_controls': 'Slider controls',
                'aspect_ratio': 'Aspect ratio',
                'slider_controls_description': 'Show slider controls.',
                'slider_time_per_slide': 'Time per slide',
                'slider_time_per_slide_description': 'Number of seconds per slide.',
                'slider_aspect_ratio_description': 'The aspect ratio determines the width and the height of the slider.',
                'image_aspect_ratio_description': 'The aspect ratio determines the width and the height of the image.',
                'add_slide': 'Add a slide',
                'zero_slide_description': 'No slides set yet.',
                'icon': 'Icon',
                'open_new_window': 'Open in new window',
                'custom_url': 'Custom URL',
                'search_url_description': 'Search for an existing page',
                'custom_url_description': 'Insert a custom URL',
                'alignment': 'Alignment',
                'size': 'Size',
                'search_url_description': 'Search for an existing page',
                'custom_url_description': 'Insert a custom URL',
                'select_a_page': 'Link to a page',
                'enter_a_custom_url': 'Enter a custom URL',
                'icon_alignment': 'Icon alignment',
                'icon_alignment_description': 'Set the alignment of the icons relative to the content.',
                'icon_alignment_top': 'Set the icon on top of the content',
                'icon_alignment_left': 'Set the icon to the left of the content',
                'icon_alignment_right': 'Set the icon to the right of the content',
                'icon_brand': 'Icon brand',
                'icon_brand_description': 'Pick a color for the icons.',
                'list_items': 'List items',
                'list_layout_description': 'Select a layout in which to display the list.',
                'top': 'Top',
                'left': 'Left',
                'right': 'Right',
                'item': 'Item',
                'amsterdam_time_zone': 'Amsterdam time zone',
                'items_per_slide': 'Images per slide',
                'items_per_slide_description': 'The number of items to display for an active slide.',
                'images': 'Images',
                'carousel_images_description': 'Upload images, drag to order or attach a link.',
                'add_image': 'Add image',
                'link_a_page': 'Link a page',
                'post_page_description': 'Open a custom page after clicking on this post.',
                'post_content_description': 'Open an auto-generated page after clicking on this post.',
                'enable_filters': 'Enable filters',
                'enable_pagination': 'Enable pagination',
                'enable_search': 'Enable search',
                'enable_news_feed_pagination_description': 'Enable pagination to show a button that allow end-users to load more posts than initially shown.',
                'enable_news_feed_filters_description': 'Enable filters to allow end-users to filter on news modules and to search posts.',
                'enable_gallery_pagination_description': 'Enable pagination to show a button that allow end-users to load more images than initially shown.',
                'enable_gallery_search_description': 'Enable search to allow end-users to filter images by searching through the alternative text and filenames.',
                'enable_action_campaign_filters_description': 'Enable filters to allow end-users to filter on campaign type, crowdfunding projects, and groups.',
                'enable_brand': 'Enable brand',
                'enable_brand_description': 'Enable brand to use the current site\'s brand colors for the social media buttons instead of the corresponding social media colors.',
                'news_modules_description': 'Select the news modules from which posts will be bundled in this feed.',
                'layout': 'Layout',
                'news_feed_layout_description': 'Select between different layouts for the feed.',
                'news_feed_number_of_posts_description': 'The number of posts to display. If you enable pagination, this is the number of posts per page.',
                'images': 'Images',
                'gallery_image_description': 'Upload your images. To hide or show an image, hover over an image and check the visibility label.',
                'hide_mobile': 'Hide on mobile',
                'hide_desktop': 'Hide on desktop',
                'mobile_aspect_ratio': 'Mobile aspect ratio',
                'mobile_custom_aspect_ratio_description': 'By default, the image will use a square aspect ratio on mobile devices. Alternatively, you can choose to keep the previously selected aspect ratio ({{ ratio }})',
                'slider_crop_mobile_description': 'By default, your slider will use a square aspect ratio on mobile devices. Alternatively, you can choose to keep the previously selected aspect ratio ({{ ratio }}).',
                'keep_aspect_ratio': 'Keep aspect ratio',
                'square': 'Square',
                'button_content': 'Button content',
                'button_content_description': 'Enter text to show a button in your card. This will help signify that this card is clickable.',

                'meta_description': 'Meta description',
                'general': 'General',
                'row': 'Row',
                'column': 'Column',
                'skin': 'Skin',
                'template': 'Template',
                'templates': 'Templates',
                'welcome': 'Welcome',
                'almost_there': 'Almost there',
                'flag': 'Flag',
                'flags': 'Flags',
                'cancel': 'Cancel',
                'role': 'Role',
                'role_of': 'Role of',
                'reverse_role': 'Reverse Role',
                'related_account': 'Related contact',
                'find_account': 'Find contact',
                'recent_activity': 'Recent activity',
                'last_activity': 'Last activity',
                'last_active': 'Last active',
                'summary': 'Summary',
                'sent_mail': 'Sent email',
                'includes': 'Includes',
                'excludes': 'Excludes',
                'select_product': 'Select product',
                'news': 'News',
                'optional': 'Optional',
                'per_page': 'Per page',
                'results_per_page': 'Results per page',
                'items_per_page': 'Items per page',
                'length_of_list': 'Length of list',
                'active_sessions': 'Active sessions',
                'roles': 'Roles',
                'allowed_locations': 'Allowed locations',
                'location': 'Location',
                'locations': 'Locations',
                'add_location': 'Add location',
                'edit_location': 'Edit location',
                'ip_address': 'IP address',
                'enter_url': 'Enter URL...',
                'limit_access_to': 'Limit access to',
                'live': 'Live',
                'access_level': 'Access level',
                'access_level_require_account_form': 'The effective access level is \'Logged in\', because the page contains a form that requires users to be logged in.',
                'all_users': 'All logged in users',
                'question': 'Question',
                'answer': 'Answer',
                'post': 'Post',
                'posts': 'Posts',
                'video_embed_url': 'Link to video',
                'video_title': 'Title',
                'news_modules': 'News modules',
                'short_title': 'Short title',
                'show_after_publication_date': 'Show after publication date',
                'publication_status': 'Publication status',
                'brand': 'Brand',
                'brand_field_description': 'Select a base color for your module.',
                'logo': 'Logo',
                'inverse_logo': 'Inverse logo',
                'header_bar': 'Header bar',
                'header_bar_description': 'The header bar floats at the top of your website and contains your logo, the main navigation, and a login button for end-users.',
                'enable_header_bar': 'Enable header bar',
                'enable_header_bar_description': 'Enabling the header bar is the easiest way to show your logo and navigation to your visitors. Disable to remove it from your website.',
                'header_bar_brand_description': 'Pick a color for your header bar.',
                'site_logo_description': 'Upload a version of your logo that can be shown on light backgrounds.',
                'site_inverse_logo_description': 'Upload a version of your logo that can be shown on dark backgrounds.',
                'footer_bar': 'Footer bar',
                'footer_bar_description': 'The footer sits at the bottom of your website and contains the footer navigation and social media links.',
                'enable_footer_bar': 'Enable footer bar',
                'enable_footer_bar_description': 'Enabling the footer bar is the easiest way to include a footer on every page of your website. Disable to remove it from your website.',
                'footer_bar_brand_description': 'Pick a color for your footer bar.',
                'transparent_at_top': 'Transparent while at the top of the page',
                'transparent_at_top_description': 'While the end-user is at the top of the page, the header bar will remain transparent. As soon as they scroll down, the background will fill in. This works best if you include a header photo at the top of each page.',
                'logo_description': 'Upload a logo to show it on your website.',
                'brand_colors_description': 'Define your brand colors so that they can be used on your website. We recommend using your brighest brand color as the primary color, and a darker color as the secondary color.',
                'social_media_desription': 'Enter your social media handles to display them on your website.',
                'tracking_codes_description': 'Enter tracking codes to track your visitors.',
                'scripts_description': 'Enter custom/third party scripts.',
                'site_settings': 'Website settings',
                'scripts': 'Scripts',
                'fonts': 'Fonts',
                'config': 'Config',
                'tracking_codes': 'Tracking codes',
                'pin_post': 'Pin post',
                'post_pin_description': 'Pin this post to keep it at the top of news overviews.',
                'single': 'Single',
                'alt_text': 'Alternative text',
                'alt_text_description': 'Provide an optional description of the image for improved accessibility.',
                'squares': 'Squares',
                'dynamic': 'Dynamic',
                'highlight': 'Highlight',
                'layout': 'Layout',
                'max_visible_grid_items': 'Maximum visible grid images',
                'gallery_max_visible_grid_items_description': 'Insert the maximum number of images which should be visible in the gallery grid.',
                'gallery_layout_description': 'Initially display a single image, a grid of images, or a grid with one highlighted image.',

                // CRM
                'about': 'About',
                'relation': 'Relation',
                'relations': 'Relations',
                'up_title': 'Up title',
                'down_title': 'Down title',
                'account': 'Contact',
                'accounts': 'Contacts',
                'account_info': 'Contact info',
                'initials': 'Initials',
                'first_name': 'First name',
                'infix': 'Infix',
                'last_name': 'Last name',
                'phone': 'Phone',
                'phone_number': 'Phone number',
                'phone_home': 'Phone (home)',
                'phone_private': 'Phone (private)',
                'phone_work': 'Phone (work)',
                'phone_emergency': 'Phone (emergency)',
                'house_number': 'House number',
                'house_number_addition': 'House nr. add.',
                'address': 'Address',
                'postal_address': 'Postal address',
                'edit_address': 'Edit address',
                'edit_postal_address': 'Edit postal address',
                'street': 'Street',
                'zip_code': 'Zip code',
                'city': 'City',
                'country': 'Country',
                'postal_house_number': 'House number (postal)',
                'postal_house_number_addition': 'House nr. add. (postal)',
                'postal_street': 'Street (postal)',
                'postal_zip_code': 'Zip code (postal)',
                'postal_city': 'City (postal)',
                'postal_country': 'Country (postal)',
                'personal': 'Personal',
                'crm_settings': 'CRM Settings',
                'interaction': 'Interaction',
                'interactions': 'Interactions',
                'interaction_subject': 'Subject',
                'interaction_subjects': 'Subjects',
                'interaction_subject_template_description': 'The summary of new interactions will be pre-filled with the template.',
                'assigned_by': 'Assigned by',
                'assigned_user': 'Assignee',
                'calendar': 'Calendar',
                'calendar_url': 'Calendar URL',
                'calendar_subscription': 'Calendar subscription',
                'subscribe_to_calendar': 'Subscribe to calendar',
                'details': 'Details',
                'personal_info': 'Personal information',
                'gender_title': {
                    'm': 'Male',
                    'f': 'Female'
                },
                'gender': 'Gender',
                'name': 'Name',
                'date_of_birth': 'Date of Birth',
                'age': 'Age',
                'private': 'Private',
                'home': 'Home',
                'work': 'Work',
                'emergency': 'Emergency',
                'group': 'Group',
                'groups': 'Groups',
                'parent_group': 'Parent group',
                'group_membership': 'Group Membership',
                'group_memberships': 'Members',
                'membership': 'Membership',
                'mail_opt_in_entry_groups': 'Entry groups',
                'mail_opt_in_entry_groups_description': 'All current and future contacts in the groups you select below will automatically receive an opt-in for this mail permission.',
                'mail_opt_ins_entry_groups_will_be_added': 'will be opted in',
                'add_mail_permission': 'Add mail permission',
                'opt_out': 'Opt-out',
                'opt_outs': 'Opt-outs',
                'default': 'Default',
                'checked_by_default': 'Checked by default',
                'make_default_mail_template': 'Make this the default mail template for new mails',
                'make_default_mail_sender': 'Make this the default mail sender for new mails',
                'order': 'Order',
                'orders': 'Orders',
                'orders_and_gifts': 'Orders & Gifts',
                'order_id': 'Order ID',
                'order_info': 'Order info',
                'order_number': 'Order number',
                'reference': 'Reference',
                'note': 'Note',
                'notes': 'Notes',
                'organisation': 'Organisation',
                'organisations': 'Organisations',
                'person': 'Person',
                'persons': 'Persons',
                'contact': 'Contact',
                'contacts': 'Contacts',
                'select_group': 'Select group',
                'is_default_bank_account': 'Default account for new orders.',
                'make_default_bank_account': 'Set as default',
                'last_update': 'Last update',
                'no_groups_yet': 'No group memberships yet',
                'no_relations_yet': 'No relations yet',
                'no_description_yet': 'No description yet',
                'not_in_segments': 'Not in any segment',
                'communication': 'Communication',
                'contact_details': 'Contact details',
                'view': 'View',
                'view_order': 'View order',
                'view_action_campaign': 'View campaign',
                'view_contact': 'View contact',
                'born': 'Born',
                'added': 'Added',
                'deleted': 'Deleted',
                'account_since': 'Contact since',
                'team': 'Team',
                'teams': 'Teams',

                // Finance
                'financial': 'Financial',
                'iban': 'IBAN',
                'bic': 'BIC',
                'bank_account': 'Bank account',
                'bank_accounts': 'Bank accounts',
                'no_bank_accounts': 'No bank accounts yet',
                'account_holder': 'Account holder',
                'orders_and_transactions': 'Orders & transactions',
                'dashboard': 'Dashboard',
                'refunded': 'Refunded',
                'refund_paid_transactions': 'Refund paid transactions',
                'refund_purchase': 'Refund purchase',
                'refund': 'Refund',
                'refund_payments': 'Refund payments',
                'cancel_payments': 'Cancel payments',
                'authorised': 'Authorised',
                'other_attempts': 'Other attempts',
                'distribution': 'Distribution',
                'new_purchase_source': 'New source',
                'new_purchase_destination': 'New destination',
                'new_label': 'New label',
                'new_project': 'New project',
                'opening': 'Opening',
                'closing': 'Closing',
                'change': 'Change',
                'changes': 'Changes',

                // Forms
                'form': 'Form',
                'forms': 'Forms',
                'form_entry': 'Form entry',
                'form_entries': 'Form entries',
                'form_entry_errors': 'There were problems creating the',
                'entries_for': 'Entries for',
                'field': 'Field',
                'form_field': 'Field',
                'form_field_choice': 'Form field choice',
                'fields': 'Fields',
                'entry': 'Entry',
                'entry_by': 'Entry by',
                'form_entry_title': 'Entry by <account-link account="account">{{ account.title }}</account-link> on {{ created_at | formatDate:\'medium\' }}',
                'form_empty_distribution_description': 'There is no distribution because the form does not contain any choices.',
                'success_message': 'Success message',
                'submit_text': 'Submit button text',
                'publish_form': 'Publish form',
                'publish_form_site_description': 'From which website should this form be reachable?',
                'form_conditions_description': 'Conditionally display this field based on what was entered elsewhere in the form.',
                'form_rules_description': 'Define constraints to the information that can be entered.',
                'form_value_description': 'Set an initial value for the field.',
                'form_choices_description': 'Define a set of choices that the end-user can choose from.',
                'show_when': 'Show when...',

                'no_results': 'No results :-(',

                'cancel_purchases_after': 'Cancel purchases after',
                'cancel_transactions_after_description': 'If left empty, all cancellable transactions will be cancelled. Otherwise, only cancellable transactions on or after the given end date will be cancelled. This field also sets the end date for recurring purchases.',

                // Mailing Lists
                'body': 'Body',
                'domain': 'Domain',
                'from': 'From',
                'till': 'Till',
                'mailing': 'Mailing',
                'mailings': 'Mailings',
                'mailing_batch': 'Mailing batch',
                'mailing_batches': 'Mailing batches',
                'transactional_mail': 'Transactional mail',
                'transactional_mails': 'Transactional mails',
                'batches': 'Batches',
                'batch_size': 'Batch size',
                'campaign': 'Campaign',
                'campaigns': 'Campaigns',
                'subject': 'Subject',
                'subjects': 'Subjects',
                'new_subject': 'New subject',
                'track_clicks': 'Track clicks',
                'track_views': 'Track views',
                'sender': 'Sender',
                'senders': 'Senders',
                'mail_sender': 'Mail sender',
                'mail_senders': 'Mail senders',
                'mail_sender_desc_description': 'Optional and for internal use only. Mail recipients will not see this description.',
                'mail_templates': 'Mail templates',
                'mail_template': 'Mail template',
                'lists': 'Lists',
                'list': 'List',
                'recipient': 'Recipient',
                'recipients': 'Recipients',
                'recipient_currently': 'Recipient (currently)',
                'recipients_currently': 'Recipients (currently)',
                'tracking': 'Tracking',
                'times_sent': 'Times sent',
                'time_sent': 'Time sent',
                'times_received': 'Times received',
                'times_opened': 'Times opened',
                'times_bounced': 'Times bounced',
                'preview': 'Preview',
                'preview_in_browser': 'Preview in browser',
                'history': 'History',
                'status_history': 'Status history',
                'test': 'Test',
                'send_test_mail': 'Send test email',
                'test_mail': 'Test email',
                'send': 'Send',
                'resend_to': 'Resend to',
                'confirm_resend_to': 'Confirm resend to',
                'sending': 'Sending',
                'send_mailing_confirmation': 'The mailing will be sent to <strong>{{ recipient_count }}</strong> contact{{ recipient_count != 1? \'s\' : \'\'}}. This process can not be reversed or stopped. Continue?',
                'info': 'Information',
                'settings': 'Settings',
                'signature': 'Signature',
                'sent_emails': 'Sent emails',
                'outgoing_emails': 'Outgoing emails',
                'personalized_sender': 'Personalized sender',
                'attempt_personalized_sender': 'If the recipient of this mailing has an internal contact person, attempt to send from contact person\'s email address',
                'fallback': 'fall-back',
                'deliveries': 'Deliveries',
                'pending': 'Pending',
                'delivery': 'Delivery',
                'hard_soft_bounces': 'Hard / soft bounces',
                'bounces': 'Bounces',
                'bounce': 'Bounce',
                'delivery_rate': 'Delivery rate',
                'open_rate': 'Open rate',
                'opens': 'Opens',
                'automation': 'Automation',
                'automated_mailing': 'Automated mailing',
                'important_mailing': 'Important mailing',
                'scheduled_mailing': 'Scheduled mailing',
                'scheduled_mailing_description': 'Want to schedule this mailing in the future, once a day at a given time, or continuously?',
                'scheduled_frequency': 'Scheduled frequency',
                'scheduled_date': 'Scheduled date',
                'scheduled_time': 'Scheduled time',
                'scheduled': 'Scheduled',
                'last_sent': 'Last sent',
                'frequency': 'Frequency',
                'once': 'Once',
                'daily': 'Daily',
                'always': 'Always',
                'continuous': 'Continuous',
                'starting_from': 'Starting from',
                'starting': 'Starting',
                'send_at': 'Send at',
                'once_per_email_address': 'Once per e-mail address',
                'once_per_email_description': 'If there are multiple recipients with the same e-mail address, send only one mail. The mail will be personalised for one recipient only.',
                'important_mail_description': 'Also send mailing to contacts that have been unsubscribed from all mailings',
                'send_mailing_automatically': 'Send mailing continuously (useful for e.g. milestones)',
                'mail_recipients_description': 'Select recipients',
                'mail_sender_description': 'Select a sender',
                'mail_subject_description': 'Set a subject',
                'mail_content_description': 'Set content',
                'send_mail_dots': 'Send mail...',
                'download_pdf_dots': 'Download PDF...',
                'download_pdf': 'Download PDF',
                'add_pdf_template': 'Add PDF template',
                'edit_pdf_template': 'Edit PDF template',
                'pdf_template': 'PDF template',
                'pdf_templates': 'PDF templates',
                'site_styles': 'Look & feel',
                'social_media': 'Social media',
                'brand_colors': 'Brand colors',
                'style_config': 'Stylesheet configuration',
                'gtm_code': 'Google Tag Manager',
                'grp_code': 'Google Remarketing Pixel',
                'ga_code': 'Google Analytics',
                'fbp_code': 'Facebook Pixel',
                'gtm_code_placeholder': 'GTM-...',
                'ga_code_placeholder': 'UA-...',
                'fbp_code_placeholder': 'Facebook Pixel',
                'unsubscribe_page': 'Unsubscribe page',
                'download': 'Download',
                'bcc': 'BCC',
                'updating_site': 'A moment please, the website is being updated.',
                'site_updated': 'The website has been updated',
                'head_scripts': 'Head scripts',
                'body_scripts': 'Body scripts',
                'color': 'Color',

                // Payments
                'amount': 'Amount',
                'enter_amount': 'Enter amount',
                'collection_date': 'Collection date',
                'next_collection_date': 'Next collection date',
                'next_collection': 'Next collection',
                'next': 'Next',
                'collect_month': 'Collection month',
                'payment_date': 'Payment date',
                'bank_statement': 'Bank statement',
                'bank_statements': 'Bank statements',
                'bank_statement_batch': 'Bank statement batch',
                'bank_statement_batches': 'Bank statement batches',
                'existing_transaction': 'Link to existing transaction',
                'new_transaction': 'Create new transaction',
                'ignore': 'Ignore',
                'match_types': 'Match types',
                'match_to_existing_transaction': 'Match to existing transaction',
                'add_new_transaction_to_existing_order': 'Add new transaction to existing order',
                'add_new_order': 'Add new order',
                'add_new_order_for': 'Add new order for',
                'add_new_order_other': 'Add new order for someone else',
                'add_to': 'Add to',
                'add_bank_statement_batch': 'Add bank statement batch',
                'process': 'Process',
                'process_unmatched_payments': 'Process unmatched payments',
                'process_payment': 'Process payment',
                'unmatched_payment': 'Unmatched payment',
                'unmatched_payments': 'Unmatched payments',
                'reversal_action': 'Reversal action',
                'reversal_code': 'Reversal code',
                'processing_bank_statement_batches': 'Processing bank statements, please wait.',
                'sdd_batch': 'Direct debit batch',
                'sdd_batches': 'Direct debit batches',
                'statement': 'Statement',
                'sdd_reversal_batch': 'Reversal batch',
                'sdd_reversal_batches': 'Reversal batches',
                'sdd_reversals': 'Reversals',
                'entries': 'Entries',
                'non_reversals': 'Non-reversals',
                'reversals': 'Reversals',
                'reversal_status': 'Reversal status',
                'untracked': 'Untracked',
                'duplicates': 'Duplicates',
                'potential_duplicate': 'Potential duplicate',
                'potential_duplicates': 'Potential duplicates',
                'merge_duplicates': 'Merge duplicates',
                'find_duplicates': 'Find duplicates',
                'similar_contacts_to': 'Contacts that are similar to {{ to }}',
                'category': 'Category',
                'categories': 'Categories',
                'new_category': 'New category',
                'select_category': 'Select category',
                'product_category': 'Product category',
                'product_categories': 'Product categories',
                'new_product_category': 'New product category',
                'count': 'Count',
                'booking_date': 'Booking date',
                'due_date': 'Due date',
                'payment': 'Payment',
                'payments': 'Payments',
                'payment_interval': 'Payment interval',
                'payment_method': 'Payment method',
                'payment_methods': 'Payment methods',
                'payment_references': 'Payment references',
                'payment_reference_config': 'Payment reference config',
                'add_payment_reference_config': 'Add payment reference config',
                'end_date': 'End date',
                'mailing_end_date_description': 'Mailing automatically stops after this date.',
                'until': 'Until',
                'oneoff': 'One-off',
                'manual': 'Manual',
                'recurring': 'Recurring',
                'start_date': 'Start date',
                'transaction': 'Transaction',
                'transaction_id': 'Transaction ID',
                'transaction_fee': 'Transaction fee',
                'payment_terms': 'Payment terms',
                'term': 'Term',
                'terms': 'Terms',
                'payment_recurring': 'Recurring payment',
                'payment_timing': 'Timing',
                'payment_timing_direct': 'At purchase',
                'payment_timing_delayed': 'After certain period',
                'payment_timing_date': 'Fixed date',
                'collect_after': 'Collect after',
                'payment_type': 'Payment type',
                'payment_types': 'Payment types',
                'days': 'days',
                'months': 'months',
                'years': 'years',
                'day': 'day',
                'month': 'month',
                'year': 'year',
                'past_week': 'Past week',
                'past_month': 'Past month',
                'yesterday': 'Yesterday',
                'today': 'Today',
                'tomorrow': 'Tomorrow',
                'next_week': 'Next week',
                'collect_on': 'Collect on',
                'repeat': 'Repeat',
                'repeat_every': 'Repeat every',
                'every': 'Every',
                'weekly': 'Weekly',
                'monthly': 'Monthly',
                'quarterly': 'Quarterly',
                'yearly': 'Yearly',
                'repeat_count': 'Repeat count',
                'repeat_at_most': 'Repeat at most',
                'collect_day': 'Day of month',
                'collect_day_desc': 'E.g., always collect on the 24th day of the month.',
                'times': 'times',
                'duration': 'Duration',
                'included_in_amount': 'Included in amount',
                'quantity': 'Quantity',
                'stock': 'Stock',
                'purchases': 'Purchases',
                'purchase': 'Purchase',
                'transactions': 'Transactions',
                'transaction_info': 'Transaction info',
                'related_info': 'Related',
                'status': 'Status',
                'mandate': 'Mandate',
                'mandate_reference': 'Mandate reference',
                'manual_payment': 'Payment',
                'invoice_payment': 'Invoice payment',
                'sdd_payment': 'Direct debit payment',
                'action': 'Action',
                'actions': 'Actions',
                'actions_applied': 'Actions applied',
                'cancel_order': 'Cancel order',
                'reason': 'Reason',
                'cancel_reason': 'Cancel reason',
                'cancel_reasons': 'Cancel reasons',
                'order_cancel_reason': 'Cancel reason',
                'order_cancel_reasons': 'Cancel reasons',
                'new_reason': 'New reason',
                'cancel_purchase': 'Cancel purchase',
                'cancel_recurring_purchase': 'Stop recurring purchase',
                'cancelled': 'Cancelled',
                'total_amount': 'Total amount',
                'transaction_count': 'Transactions',
                'sequence_type': 'Sequence type',
                'totals': 'Totals',
                'total': 'Total',
                'gross': 'Gross',
                'net': 'Net',
                'creditor': 'Creditor',
                'creditor_id': 'Creditor ID',
                'creditor_name': 'Creditor name',
                'creditor_iban': 'Creditor IBAN',
                'creditor_bic': 'Creditor BIC',
                'set_sdd_batch_status': 'Set status: {{ \'sdd_batch_statuses.\' + status | translate }}',
                'set_status': 'Set status',
                'download_xml_file': 'Download XML file',
                'mark_as_finalized': 'Mark as finalized',
                'mark_as_reversed': 'Mark as reversed',
                'mark_as_refunded': 'Mark as refunded',
                'reverse_transaction_retry': 'Try collecting this transaction again.',
                'refund_transaction_description': 'This will only <em>mark</em> the transaction as refunded for administrative purposes. <strong>No money will be transferred</strong>. Please refund the money through your banking environment or payment service provider.',
                'export': 'Export',
                'exports': 'Exports',
                'import': 'Import',
                'imports': 'Imports',
                'import_info': 'Import info',
                'records': 'Records',
                'invalid_records': 'Invalid records',
                'valid_records': 'Valid records',
                'analysed_at': 'Analysed at',
                'imported_at': 'Imported at',
                'uploaded_at': 'Uploaded at',
                'uploaded_by': 'Uploaded by',
                'import_group_desc': 'Import into group',
                'dedup_strategy': 'Deduplication strategy',
                'dedup_strategy_desc': 'What would you like to do with possibly duplicate records?',
                'dedup_strategy_ignore': 'Import anyway',
                'dedup_strategy_skip': 'Do not import',
                'import_refused_desc': 'The import has been refused because it contains invalid records. Please fix the validation errors listed below and retry.',
                'import_failed_desc': 'The import has been refused for the following reason',
                'rows': 'Rows',
                'columns': 'Columns',
                'valid_columns_desc': 'The following columns are recognised by One Community.',
                'ignored_columns_desc': 'The following columns will be <strong>ignored</strong>.',
                'statuses': 'Statuses',
                'open': 'Open',
                'paid': 'Paid',
                'paused': 'Paused',
                'started': 'Started',
                'stopped': 'Stopped',
                'active': 'Active',
                'inactive': 'Inactive',
                'an_active': 'An active',
                'an_inactive': 'An inactive',
                'with_selection': 'With selection',
                'finished': 'Finished',
                'unfinished': 'Unfinished',
                'to_do': 'To do',

                // Discount codes
                'apply': 'Apply',
                'approach': 'Approach',
                'blacklist': 'Blacklist',
                'code': 'Code',
                'discount': 'Discount',
                'apply_discount': 'Apply discount',
                'calculate_discount': 'Calculate discount',
                'discount_code': 'Discount code',
                'discount_codes': 'Discount codes',
                'discount_code_status_description': 'Should this discount code be enabled, disabled or only enabled within a period?',
                'max_usage': 'Maximum usage',
                'whitelist': 'Whitelist',

                // Products
                'products': 'Products',
                'product': 'Product',
                'product_code': 'Product code',
                'price': 'Price',
                'vat': 'VAT',
                'vat_inclusive': 'VAT inclusive',
                'vat_exclusive': 'VAT exclusive',
                'incl': 'Incl.',
                'excl': 'Excl.',
                'pricing': 'Pricing',
                'allow_custom_amount': 'Variable amount (for e.g. gifts and donations)',
                'variable_amount': 'Variable amount',
                'fixed_amount': 'Fixed amount',
                'max_sales_count': 'Maximum number of sales',

                'product_info': 'Product details',
                'payment_info': 'Payment details',
                'purchase_info': 'Purchase details',
                'purchase_source': 'Source',
                'purchase_sources': 'Sources',
                'purchase_destination': 'Destination',
                'purchase_destinations': 'Destinations',
                'set_purchase_src_dst_description': 'Set purchase source or destination',
                'purchase_src_dst_description': 'Setting the source and/or destination of purchases can be used to, for example, distinguish between marketing channels in the Finance dashboard.',
                'payment_method_fee': 'Payment method fee',
                'product_payment_method_fee_description': 'Automatically add this product to orders with selected payment methods as a payment method fee (used by quick donations only).',

                'collect_max': 'Collect max',
                'collect_date': 'Collect date',

                'limit': 'Limit',
                'show': 'Show',
                'showing': 'Showing',

                // Segments
                'calculating_changes': 'Calculating changes...',
                'review_segment_changes_description': 'Saving your changes will have the following effects. Please review carefully before continuing.',
                'review_changes': 'Review changes',
                'segments': 'Segments',
                'segment': 'Segment',
                'rule': 'Rule',
                'requirement': 'Requirement',
                'filters': 'Filters',
                'move_up': 'Move up',
                'move_down': 'Move down',
                'subcondition': 'Subcondition',
                'condition_group': 'Condition group',
                'and_operator_description': 'All conditions must be satisfied',
                'or_operator_description': 'At least one condition must be satisfied',
                'choose_field': 'Choose field...',
                'choose_operator': 'Choose operator...',
                'choose_value': 'Choose value...',
                'enter_value': 'Enter value...',
                'do_have': 'have',
                'do_not_have': 'don\'t have',
                'have_not': 'have not',
                'are': 'are',
                'are_not': 'are not',
                'a_member_of': 'a member of',
                'the_owner_of': 'the owner of',
                'a_member_or_the_owner_of': 'a member or the owner of',
                'has_selected_all_of': 'Contact has selected all of',
                'has_selected_any_of': 'Contact has selected any of',
                'add_criteria_based_on': 'Add criteria based on...',
                'include_contacts_that': 'Include only contacts that...',
                'add_account_criteria': 'Contact details',
                'add_group_criteria': 'Groups',
                'add_form_entry_criteria': 'Forms',
                'add_segment_criteria': 'Other segments',
                'add_sent_mail_criteria': 'Outgoing emails',
                'add_action_campaign_criteria': 'Campaigns',
                'segments_account_filter_block_title': '... meet',
                'segments_annual_payment_filter_block_title': '... meet',
                'segments_group_filter_block_title': '... meet the following group criteria',
                'segments_segment_filter_block_title': '... meet the following subsegment criteria',
                'segments_action_campaign_filter_block_title': 'a crowdfunding campaign',
                'segments_an_action_campaign': 'a campaign',
                'segments_is_member_of_action_campaign': 'Is member of a team or open campaign',
                'segments_that_meets_criteria': 'that meets the following criteria',
                'segments_form_entry_filter_block_title': '... ',
                'segments_that': 'that',
                'segments_that_meets_any': 'That meets ANY of the following criteria...',
                'segments_that_meets_all': 'That meets ALL of the following criteria...',
                'include_contacts_that_are_in': 'Include contacts that are in',
                'exclude_contacts_that_are_in': 'Exclude contacts that are in',
                'of_the_following_groups': 'of the following groups...',
                'of_the_following_segments': 'of the following segments...',
                'include_contacts_that_have_been_sent': 'Include contacts that have been sent',
                'exclude_contacts_that_have_been_sent': 'Exclude contacts that have been sent',
                'of_the_following_mails': 'of the following mails...',
                'of': 'Of',
                'of_an_action_campaign': 'Of a campaign',
                'anything': 'Anything',
                'any_choice': 'Any choice',

                'image': 'Image',
                'cover_image': 'Cover image',
                'image_and_video': 'Image & video',
                'reverse': 'Reverse',
                'with': 'With',
                'direct': 'Direct',
                'date': 'Date',
                'publication_date': 'Publication date',
                'time': 'Time',
                'post_title_description': 'Enter the full title.',
                'post_short_title_description': 'Enter a short title that can be used in news overviews.',
                'post_intro_description': 'Enter a short description that can be used in news overviews.',
                'confirm': 'Confirm',
                'confirmation_needed': 'Confirmation needed',
                'insert_row': 'Insert row',
                'insert_module': 'Insert module',
                'select_module': 'Select module',
                'create_new': 'Create new',
                'select_template': 'Select a template',
                'select_file': 'Select file',
                'select_file_dots': 'Select file...',
                'select_image': 'Select image',
                'default_image': 'Default image',
                'select_pdf_template': 'Select PDF template',
                'publish': 'Publish',
                'published': 'Published',
                'public': 'Public',
                'login': 'Login',
                'logout': 'Logout',
                'activate_account': 'Activate account',
                'activate_account_description': 'Almost there! Set your password and you are ready to go.',
                'forgot_password': 'Forgot password',
                'forgot_password_description': 'Enter your email address and we will send you a link to reset your password.',
                'password_reset_mail_sent': 'We have sent an email containing instructions on how to reset your password to your email address.',
                'password_reset_mail': 'Reset password mail',
                'send_password_reset_mail': 'Send password reset mail',
                'reset_password': 'Reset password',
                'invisible': 'Invisible',
                'access': 'Access',
                'url_title': 'URL title',
                'custom_url_title': 'Enter custom URL',
                'custom': 'Custom',
                'automatic': 'Automatic',
                'visit': 'Visit',
                'module_label_description': 'The label is not visible in the front-end, name this module as you prefer.',
                'less': 'Less',
                'more': 'More',
                'hidden': 'Hidden',
                'visible': 'Visible',
                'close': 'Close',
                'to_accounts': 'To: contacts',
                'to_groups': 'To: groups',
                'to_segments': 'To: segments',
                'no_accounts_selected': 'The mailing will be sent to the selected contacts, even if they have received this mailing before or are unsubscribed.',
                'send_mailing_to': 'Send mailing to',
                'send_mailing_to_groups_description': 'The mailing will be sent to all contacts in the selected groups that have not received this mailing before.',
                'send_mailing_to_segment_description': 'The mailing will be sent to all contacts in the configured segment that have not received this mailing before.',
                'delivered': 'Delivered',
                'bounced': 'Bounced',
                'dropped': 'Dropped',
                'failed': 'Failed',
                'failure': 'Failure',
                'failures': 'Failures',
                'to': 'To',
                'opened': 'Opened',
                'sent': 'Sent',
                'attach_file': 'Attach file',
                'attachment': 'Attachment',
                'attachments': 'Attachments',
                'file_attachments': 'File attachments',
                'pdf_template_attachments': 'PDF attachments',
                'no_attachments_selected': 'No attachments selected',
                'clicks': 'Clicks',
                'criterion': 'Criterion',
                'criteria': 'Criteria',
                'add_criteria': 'Add criteria...',
                'add_criterion': 'Add criterion...',
                'add_extra_criteria': 'Add extra criteria',
                'account_id': 'Contact ID',
                'account_type': 'Contact type',
                'account_types': 'Contact types',
                'cancelled_at': 'Cancelled at',
                'created_at': 'Created at',
                'date_created': 'Date created',
                'confirmation_mail': 'Confirmation mail',
                'confirmation_mails': 'Confirmation mails',
                'confirmation_mails_will_be_sent': 'Confirmation mails (will be sent)',
                'gift_mail': 'Gift mail',
                'gift_mail_for_participants': 'Gift mail for participants',
                'add_sponsors_to_group': 'Add sponsors to group',
                'start': 'Start',
                'end': 'End',
                'start_month': 'Start month',
                'end_month': 'End month',
                'show_monthly': 'Show monthly',

                'set_internal_contact_person': 'Link internal user',
                'contact_of': 'Contact of',
                'contact_person': 'Contact person',
                'contact_persons': 'Contact persons',
                'contact_user': 'Contact person',
                'none': 'None',
                'in_groups': 'In groups',

                'trend_tooltip': 'Trend: relative change of open + paid',

                'not_authorised': 'Not authorised',

                'overview': 'Overview',

                'recurring_active': 'Recurring',
                'recurring_decay': 'Decay',
                'sales': 'Sales',
                'sales_over_time': 'Sales over time',
                'revenue': 'Revenue',
                'back': 'Back',
                'forward': 'Forward',
                'decay': 'Decay',
                'no_stats_yet': 'No statistics yet...',
                'number_of_purchases_per_month': 'Number of purchases per month',
                'total_purchases_description': 'All payments, including cancelled and failed payments',
                'authorised_purchases_description': 'Only authorised and successful payments',
                'finance': 'Finance',
                'number_of_posts': 'Number of posts',

                'convert_to_invoice': 'Convert to invoice',
                'action_cannot_be_undone': 'This action cannot be undone.',
                'too_many_records': 'The selection contains too many records (max. {{ limit | number }})',

                'on': 'on',
                'at': 'at',
                'example': 'Example',
                'example_given': 'E.g.',
                'thank_you': 'Thank you',
                'thank_you_message_for_sponsors': 'Thank you message for sponsors',

                'used_on': 'Used on',
                'nowhere': 'Nowhere',

                'remove_from_page': 'Remove from this page',

                'unsaved_changes': 'Unsaved changes',
                'unsaved_changes_continue': 'You have unsaved changes. Before you continue, do you want to keep or discard them?',

                'simple_search': 'Simple search',
                'reset': 'Reset',
                'reset_all': 'Reset all',

                'subgroup_of': 'Subgroup of',
                'old': 'Old',
                'no_cycles_groups': 'Group cannot (indirectly) be a subgroup of itself.',
                'members_will_be': 'Members of this group will be',
                'removed': 'Removed',
                'show_subgroups': 'Show/hide subgroups',
                'show_subforms': 'Show/hide subforms',
                'subgroup': 'Subgroup',
                'subgroups': 'Subgroups',

                'placeholders': 'Placeholders',
                'mail_template_placeholders_intro': 'Placeholders can be filled with content by the user of this mail template. Create a placeholder as follows:',
                'width': 'Width',
                'height': 'Height',
                'default_url': 'Default URL',
                'url': 'URL',
                'link': 'Link',

                'display_options': 'Display options',
                'sort_by': 'Sort by',
                'sort_direction': 'Sort direction',
                'layout': 'Layout',

                'archived': 'Archived',
                'all': 'All',
                'unarchived': 'Unarchived',

                'billing': 'Billing',
                'unit_price': 'Unit price',
                'billing_explanation_title': 'How are contacts and transactions counted?',
                'billing_explanation_contacts': 'the number of contacts that were active for at least 28 days during the respective billing period.',
                'billing_explanation_transactions': 'the number of transactions that received the status paid for the first time during the respective billing period.',

                'import_explanation_title': 'How to import accounts?',
                'used_in': 'Used in',
                'editable': 'Editable',
                'require_account': 'Require existing contact',
                'allow_outsiders': 'Public',
                'language': 'Language',
                'direct_input': 'Direct input',
                'rules': 'Rules',
                'minimum': 'Minimum',
                'maximum': 'Maximum',
                'add_choice': 'Add choice',
                'number_of_choices': 'Number of choices',
                'minimum_number_of_choices': 'Minimum number of choices',
                'maximum_number_of_choices': 'Maximum number of choices',
                'creates': 'Creates',
                'updates': 'Updates',
                'form_creates': 'Created by form',
                'form_updates': 'Updated by form',
                'create': 'Create',
                'update': 'Update',
                'updating': 'Updating',
                'updated': 'Updated',
                'restore': 'Restore',
                'hide': 'Hide',
                'disabled_choices': 'Disabled choices',
                'disabled_choices_description': 'These choices will be invisible for users, but can be restored when needed.',
                'deleted_choices': 'Deleted choices',
                'deleted_choices_description': 'Once you save, these choices will be permanently deleted, including their submitted entries.',
                'choices_description': 'Add choices if you want the user to choose out of a fixed set of choices. If you don\'t add any choices, it will be an open field.',
                'default_value_description': 'The field will be prefilled with the default value. Leave empty if you want to add choices.',
                'is_other_choice': 'Is \'other\' choice',
                'other': 'Other...',
                'new_choice': 'New choice...',
                'redirect_users_to': 'Redirect logged in users to',
                'redirect_non_users_to': 'Redirect logged out users to',
                'redirect_others_to': 'Redirect others to',
                'redirect_to': 'Redirect to',
                'redirect_visitable': 'Redirect page',
                'level': 'Level',
                'allow_access_to': 'Allow access to',

                'allow_multiple_form_entries': 'Allow multiple form entries per end-user',
                'form_entries_editable': 'Submitted form entries can be edited by end-users',
                'form_field_entries_not_editable': 'Existing entries cannot be edited by end-users',
                'save_entry': 'Save form entries',

                'end_user_settings': 'End-users',
                'allow_multiple_description': 'Can end-users submit this form multiple times or only once?',
                'editable_description': 'Can end-users edit their previously submitted form entries?',
                'allow_multiple_yes_description': 'Form can be submitted multiple times by the same contact.',
                'allow_multiple_no_description': 'Form can only be submitted once per contact.',
                'editable_yes_description': 'Submitted form entries can be edited.',
                'editable_no_description': 'Submitted form entries can not be edited.',

                'form_set_title_description': 'Choose a title',
                'form_set_scope_description': 'Select the target audience',
                'form_set_fields_description': 'Build the form',

                'form_scope_label': 'Who is this form for?',
                'form_scope_create_account': 'New contacts',
                'form_scope_create_account_description': 'Each form entry will create a new contact',
                'form_scope_update_account': 'Logged in contacts only',
                'form_scope_update_account_description': 'Form entries can only be submitted by contacts that are logged in',
                'scope': 'Scope',

                'activate_field_when': 'Activate this field when...',
                'activate_field_when_not_empty': 'Activate this field when not empty',
                'equals': 'Equals',
                'contains': 'Contains',
                'contains_one_of': '...contains one of...',

                'configure_form': 'Configure form',
                'actions': 'Actions',

                'page_not_found': 'Page not found',

                'history': 'History',
                'yes': 'Yes',
                'no': 'No',

                'action_campaigns': 'Campaigns',
                'action_campaign': 'Campaign',
                'action_project': 'Project',
                'action_projects': 'Projects',
                'parent_campaign': 'Parent campaign',

                'ascending': 'Ascending',
                'descending': 'Descending',

                'variable': 'Variable',
                'variable_key': 'Variable',
                'variable_value': 'Value',
                'purchase_payment_term': 'Payment term',
                'new_contacts': 'New contacts',
                'new_orders': 'New orders',
                'new_transactions': 'New transactions',

                'gift_amount': 'Funds raised',
                'total_gift_amount': 'Total funds raised',
                'total_gift_amount_desc': 'Sum of donations to active campaigns + project donations',
                'action_project_gift_amount': 'Project funds raised',
                'action_campaign_gift_amount': 'Campaign funds raised',
                'membership_gift_amount': 'Participant funds raised',
                'target': 'Target',
                'fundraising_target': 'Fundraising target',
                'individual': 'Individual',
                'campaigner': 'Participant',
                'owner': 'Owner',
                'members': 'Members',
                'activate': 'Activate',
                'deactivate': 'Deactivate',
                'reactivate': 'Reactivate',
                'closed': 'Closed',
                'campaigner_and_team': 'Participant & team',
                'owner_and_team': 'Owner & team',
                'active_action_project': 'Active project',
                'active_action_projects': 'Active projects',
                'active_action_campaign': 'Active campaign',
                'active_action_campaigns': 'Active campaigns',
                'active_membership': 'Active participant',
                'active_memberships': 'Active participants',
                'show_name': 'Show name',
                'show_amount': 'Show amount',
                'message': 'Message',
                'display': 'Display',
                'show_n_more': 'Show {{ n }} more...',
                'used_on_n_pages': 'Used on {{ n }} page{{ n != 1 ? \'s\' : \'\' }}',
                'n_results': '{{ n }} result{{ n != 1 ? \'s\' : \'\' }}',
                'n_items': '{{ n }} item{{ n != 1 ? \'s\' : \'\' }}',
                'no_information': 'No information',
                'overview_type': 'Overview type',
                'action_campaign_types': 'Campaign types',
                'set_default_header': 'Use as default header {{ language ? \'(\' + language + \')\' : \'\' }}',
                'set_default_footer': 'Use as default footer {{ language ? \'(\' + language + \')\' : \'\' }}',
                'saving': 'Saving',
                'form_entry_affected_entities_description': 'Saving this form entry has the following consequences:',
                'no_confirmation_mail_will_be_sent': 'No confirmation mails will be sent',
                'will_not_affect': 'Will not affect',
                'finalize': 'Finalize',
                'support': 'Support',
                'account_type_name': 'Contact type',

                'action_campaign_types_description': 'Choose which types of campaigns may be created within this project. For each type you can configure which fields may be used and edited by the end-user.',
                'action_project_groups_description': 'Assign labels to participants in specific groups. These can be filtered on and are displayed in overviews and on profile pages, allowing you to differentiate between different types of campaigns and participants.',
                'group_labels': 'Group labels',

                'my_to_dos': 'My to-dos',
                'assign_to_me': 'Assign to me',
                'subscribe_to_mails': 'Subscribe to mailings',
                'unsubscribe_from_mails': 'Unsubscribe from mailings',
                'subscribed': 'Subscribed',
                'unsubscribed': 'Unsubscribed',

                'untitled': 'Untitled',
                'structure': 'Structure',
                'performance': 'Performance',
                'immediately': 'Immediately',
                'schedule': 'Schedule',
                'add_date': 'Add date',
                'one_week_later': '1 week later',
                'one_month_later': '1 month later',
                'generate_exports_on': 'Generate export(s) on',
                'ready': 'Ready',
                'personalized': 'Personalized',
                'stop': 'Stop',
                'draft': 'Draft',

                'dashboards': 'Dashboards',
                'transaction_statuses': 'Transaction statuses',
                'show_n_hidden_categories': 'Show {{ n }} hidden {{ n == 1 ? \'category\' : \'categories\' }}',
                'show_compact_list': 'Show compact list',
                'advanced': 'Advanced',
                'required_settings': 'Required settings',
                'optional_settings': 'Optional settings',
                'footnote': 'Footnote',
                'untitled_page': 'Untitled page',
                'multiple_choice': 'Multiple choice',
                'selection': 'Selection',
                'open_field': 'Open field',
                'dashboards': 'Dashboards',
                'member_of': 'Member of',
                'selected': 'Selected',
                'to_action_project': 'To: project',
                'to_action_campaign': 'To: campaign',
                'to_account': 'To: contact',
                'to_group': 'To: group',
                'ideal_bank': 'iDEAL bank',
                'idin_bank': 'iDIN bank',
                'action_campaign_type': 'Campaign type',
                'visible_fields': 'Visible fields',
                'hidden_fields': 'Hidden fields',
                'disabled_fields': 'Disabled fields',
                'visibility': 'Visibility',
                'form_open_fields_description': 'Allow the end-user to enter a custom value directly.',
                'form_multiple_choice_fields_description': 'Allow the end-user to select exactly one choice.',
                'form_selection_fields_description': 'Allow the end-user to make a selection of choices.',
                'getting_started': 'Getting started',
                'tip': 'Tip',
                'form_getting_started_description': 'Create your form by adding fields. Fields can be <i class="md-icon">short_text</i> <strong>open-ended</strong>, <i class="md-icon">radio_button_checked</i> <strong>multiple choice</strong>, or a <i class="md-icon">check_box</i> <strong>selection</strong> of multiple answers. After adding them, you can <i class="md-icon text-muted">drag_indicator</i> drag and drop them into the desired arrangement here.',
                'form_hidden_fields_description': 'Hidden fields are hidden to the end-user, but they are fully functional. Use hidden fields to automatically preselect a value without showing it to the end-user.',
                'form_disabled_fields_description': 'Disabled fields are invisible and non-functional. They can be reactivated at any time.',
                'deleted_at': 'Deleted at',
                'deactivated_at': 'Deactivated at',
                'required_fields': 'Required fields',
                'share_gift_amount': 'Share gift amount',
                'dont_share_gift_amount': 'Don\'t share gift amount',
                'deactivated': 'Deactivated',
                'need_more_form_states': 'Need a custom condition? Submit a ticket and we\'ll help you out.',
                'minimum_quantity': 'Minimum quantity',
                'maximum_quantity': 'Maximum quantity',
                'minimum_amount': 'Minimum amount',
                'maximum_amount': 'Maximum amount',
                'unique': 'Unique',
                'campaign_title_description': 'Shown to end-users when they unsubscribe from mails',
                'campaign_site_description': 'Website for unsubscribe links',
                'important': 'Important',
                'tag': 'Tag',
                'tags': 'Tags',
                'all_tags': 'All tags',
                'tagged': 'Tagged',
                'untagged': 'Untagged',
                'manage_tags': 'Manage tags',
                'add_tag': 'Add tag',
                'no_tags': 'No tags',

                'other_required': '\'Other\' value is required',
                'non_members_only': 'Allow non-members only',
                'team_member': 'Team member',
                'participant': 'Participant',
                'participants': 'Participants',
                'allow_action_projects': 'Allow projects',
                'allow_action_campaigns': 'Allow campaigns',
                'anonymous': 'Anonymous',
                'form_page': 'Form page',
                'column': 'Column',
                'allow_multiple': 'Allow multiple',
                'joined': 'Joined',
                'interacted': 'Interacted',
                'submitted': 'Submitted',
                'received': 'Received',
                'attached': 'Attached',
                'purchased': 'Purchased',
                'linked_to': 'Linked to',
                'used_by': 'Used by',
                'segment_is_used_in': 'This segment is used in',
                'and': 'And',
                'other_segments': 'Other segments',
                'no_change': 'No change',
                'send_confirmation_mail': 'Send confirmation mail',
                'form_entry_mail_no_recipients': 'No recipients. Did you check if the form entry\'s contact has an email address?',
                'will_be_notified': '{{title }} will be notified',
                'shared_with_contact': 'Shared with contact',
                'share_with': 'Share with',
                'reply': 'Reply',
                'outgoing': 'Outgoing',
                'received': 'Received',
                'unassigned': 'Unassigned',
                'created_by': 'Created by',
                'assigned_to': 'Assigned to',
                'select_applicable_products': 'Select applicable products',
                'style': 'Style',
                'optimized': 'Optimized',
                'default_mail_template_description': 'Sleek and flexible, "it just works" template with customizable options. Looks great on mobile. Automatically includes a summary of the order or form entry in transactional mail.',
                'custom_mail_template_description': 'Full customizability for the technologically savvy. Building a template from scratch requires deep understanding of HTML and CSS.',
                'mobile': 'Mobile',
                'desktop': 'Desktop',
                'add_column': 'Add column',
                'insert_content': 'Insert content',
                'reverse_columns': 'Reverse column order',
                'compact_view': 'Compact view',
                'attributes': 'Attributes',
                'theme': 'Theme',
                'edit_module': 'Edit module',
                'delete_module': 'Delete module',
                'move_row_up': 'Move row up',
                'move_row_down': 'Move row down',
                'delete_row': 'Delete row',
                'delete_column': 'Delete column',
                'increase_width': 'Increase width',
                'decrease_width': 'Decrease width',
                'something_went_wrong': 'Something went wrong...',
                'select_existing': 'Select existing',
                'or_drag': 'or drag here',
                'product_photos': 'Product photos',
                'left': 'Left',
                'center': 'Center',
                'right': 'Right',
                'sm': 'Small',
                'md': 'Standard',
                'lg': 'Large',
                'viewing_individual_campaigner': 'You\'re currently viewing the participant of an individual campaign. View the campaign for more details.',
                'general_website_details_form': 'Enter some general details that will be displayed on the website.',
                'general_action_campaign_form': 'Who is running this campaign and for which project?',
                'page_general_description': 'Enter some general information about the page. The title is required, the rest is optional.',
                'page_access_description': 'Control who is allowed to view this page and set a redirect if necessary.',
                'basic': 'Basic',
                'basic_form_scope_title': 'Add a basic field',
                'basic_form_scope_description': '',
                'account_form_scope_title': 'Add a field that updates a <strong><i class="md-icon">person</i> Contact</strong>',
                'account_form_scope_description': '',
                'order_form_scope_title': 'Add a field that builds an <strong><i class="md-icon">shopping_basket</i> Order</strong></h4>',
                'order_form_scope_description': 'If you wish to build an order, make sure to include at least one <strong>Order › Product</strong> field and an <strong>Order › Payment method</strong> field. Depending on the payment methods you want to offer, you may also need to include an <strong>Order › iDEAL bank</strong> and <strong>Order › IBAN</strong> field.',
                'action_campaign_form_scope_title': 'Add a field that updates a <strong><i class="md-icon">group_work</i> Campaign</strong>',
                'action_campaign_form_scope_description': 'If you wish to create a campaign, make sure to include at least one <strong>Campaign › Type</strong> and one <strong>Project</strong> field. These can also be added as <strong><i class="md-icon">visibility_off</i> Hidden fields</strong>.',
                'other_form_scope_title': 'Add a miscellaneous field',
                'other_form_scope_description': '',
                'n_files_uploaded': '{{ n }} file{{ n != 1 ? \'s\' : \'\' }} uploaded',
                'viewing_individual_campaigner': 'You\'re currently viewing the participant of an individual campaign. View the campaign for more details.',
                'general_website_details_form': 'Enter some general details that will be displayed on the website.',
                'general_action_campaign_form': 'Who is running this campaign and for which project?',
                'page_general_description': 'Enter some general information about the page. The title is required, the rest is optional.',
                'page_access_description': 'Control who is allowed to view this page and set a redirect if necessary.',
                'use_as_header_nav': 'Use as {{ language || \'default\' }} header navigation',
                'use_as_footer_nav': 'Use as {{ language || \'default\' }} footer navigation',
                'structure': 'Structure',
                'ok': 'OK',
                'header_nav_description': 'The header navigation sits at the top of your website and is the main navigation. Each item can be a link to a page (either to an external website or to an internal page) or simple text (recommended for the top-level item of a dropdown menu), and your navigation can contain at most one sub-level.',
                'footer_nav_description': 'The footer navigation sits at the bottom of your website.',
                'drop_sub_page_nav_link': 'Drop to add a sub link',
                'drop_root_page_nav_link': 'Drop to create a category',
                'insert_sub_page_nav_links': 'Add or drop links to create a sub menu',
                'link_to_a_page': 'Link to a page',
                'image_link_to_a_page': 'If you want, you can make the image clickable. If you do, make sure there are no links in the content field.',
                'enter_an_url': 'Enter an URL',
                'upload_image_description': 'Upload the image to display on your website.',
                'image_content_description': 'If you want, you can enter content to show on top of the image. Remember it has to fit mobile screens too.',
                'use_original': 'Use original',
                'use_aspect_ratio': 'Use custom aspect ratio',
                'display_as_button': 'Display as button',
                'button': 'Button',
                'languages': 'Languages',
                'quick_donations': 'Donation requests',
                'suggested_amount': 'Suggested amount',
                'action_project_qr_payment_method_description': 'Select the iDEAL payment method that you want to use for donation requests, for example through QR codes.',
                'fundraising': 'Fundraising',
                'gift_product': 'Fundraising product',
                'action_project_gift_product_description': 'Select the product that you want to use for gifts to this project. Gifts to this project will automatically select this product. Moreover, you can set a thank you message that will be shown to sponsors if the sponsor form has no success page.',
                'calendar_description': 'You can automatically add your to-dos to your Outlook, Google Calendar or Apple Calendar calendar by subscribing to the calendar URL below.',
                'show_to': 'Show to',
                'duplicate': 'Duplicate',
                'parent_group_description': 'Select the group from which the end-user should select a sub group.',
                'events': 'Events',
                'upgrades': 'Upgrades',
                'tickets': 'Tickets',
                'ticket': 'Ticket',
                'or_select_existing_product': 'Or select an existing product',
                'crowdfunding': 'Crowdfunding',
                'event_general_description': 'What is the name of your event?',
                'event_tickets_description': 'When a participant buys a ticket for your event, they will pay for a product and be placed in a group.',
                'event_group_description': 'Enter the name of this ticket. Participants with this ticket will end up in this group.',
                'event_ticket_products_description': 'Select the product corresponding to this ticket. If you want to offer both direct and spread payments, then you can select multiple products.',
                'event_crowdfunding_description': 'If your event involves crowdfunding, select a project in which participants get a campaign.',
                'enable_crowdfunding': 'Enable crowdfunding',
                'event_upgrades_description': 'Select the products you want to offer to your participants as upgrades.',
                'event_payment_methods_description': 'Select the payment methods you want to enable for checkout.',
                'select_a_group': 'Select a group...',
                'select_a_product': 'Select a product...',
                'select_a_payment_method': 'Select a payment method...',
                'cause': 'Cause',
                'cause_title': 'Cause (title)',
                'cause_iban': 'Cause (IBAN)',
                'max_number_of_accounts': 'Maximum number of contacts',
                'registration_page': 'Registration page',
                'select_transactional_mail': 'Select an existing transactional mail',
                'or_create_new': 'Or create new',
                'create_transactional_mail': 'Create transactional mail',
                'ticket_title_example': 'General, 5 KM, volunteer, ...',
                'be_careful': 'Be careful.',
                'action_campaign_type_change_warning': 'Changing the type of the campaign will remove {{ n }} member{{ n != 1 ? "s" : "" }} from this campaign. The member campaign{{ n != 1 ? "s" : "" }} will continue to exist as{{ n == 1 ? " an" : "" }} individual campaign{{ n != 1 ? "s" : "" }}.',

                'reminder_mail': 'Payment reminder',
                'reminder_mail_description': 'Automatically send a reminder for upcoming payments 28 and 7 days in advance (useful for products with multiple terms).',

                'open_in_atleta': 'Open in Atleta',
                'atleta_summary': 'Registration summary',
                'include_atleta_summary': 'Include a summary of the participant\'s registration under the content',

                'tracking_data': 'Tracking data',
                'unknown': 'Unknown',
            },
            'action_campaign_types': {
                'individual': 'Individual',
                'team': 'Team',
                'open': 'Open'
            },
            'action_campaign_type_descriptions': {
                'individual': 'Individual campaigns are personal and do not have any members. However, they can become a member of a team or open campaign',
                'team': 'Team campaigns have members but are not open to the world. Gifts are divided over the members.',
                'open': 'Open campaigns have members and anyone can join them. Gifts are not divided over the members.'
            },
            'export_scopes': {
                'transactions': 'Transactions',
                'accounts': 'Contacts',
                'action_campaigns': 'Campaigns',
                'bank_statement_entries': 'Bank statements',
                'discount_code': 'Discount code',
                'group': 'Group',
                'gifts': 'Gifts',
                'form': 'Form',
                'form_entries': 'Form entries',
                'segment': 'Segment',
                'product': 'Product',
                'products': 'Products',
                'purchases': 'Purchases',
                'payment_references': 'Payment references',
                'order_pdfs': 'Order PDFs',
                'interactions': 'Interactions'
            },
            'export_statuses': {
                'generating': 'Generating',
                'failed': 'Failed',
                'ready': 'Ready',
                'requested': 'Requested'
            },
            'import_statuses': {
                'analysing': 'Analysing',
                'analysed': 'Analysed',
                'importing': 'Importing',
                'imported': 'Imported',
                'failed': 'Failed',
                'refused': 'Refused'
            },
            'transaction_statuses': {
                'authorised': 'Authorised',
                'cancelled': 'Cancelled',
                'error': 'Error',
                'expired': 'Expired',
                'in_progress': 'In progress',
                'paid': 'Paid',
                'paused': 'Paused',
                'received': 'Received',
                'refused': 'Refused',
                'refunded': 'Refunded',
                'reversed': 'Reversed',
            },
            'transaction_actions': {
                'authorise': 'Authorise',
                'finalize': 'Finalize',
                'cancel': 'Cancel',
                'reverse': 'Reverse',
                'pause': 'Pause',
                'refund': 'Refund'
            },
            'bank_statement_batch_statuses': {
                'error': 'Error',
                'importing': 'Importing',
                'matching': 'Matching',
                'processed': 'Processed',
                'wait_for_matching': 'Waiting'
            },
            'sdd_batch_statuses': {
                'cancelling': 'Cancelling',
                'cancelled': 'Cancelled',
                'generating': 'Generating',
                'processing': 'Processing',
                'processed': 'Processed',
                'ready': 'Ready',
                'requested': 'Requested',
                'submitted': 'Submitted'
            },
            'sdd_reversal_batch_statuses': {
                'processing': 'Processing',
                'processed': 'Processed',
                'refused': 'Refused',
                'submitted': 'Submitted'
            },
            'forms': {
                'add': 'Add',
                'edit': 'Save',
                'save': 'Save',
                'select': 'Select',
                'process': 'Process',
                'cancel': 'Cancel',
                'close': 'Close',
                'confirm': 'Confirm',
                'got_it': 'Got it!',
                'login': 'Log in',
                'continue': 'Continue',
                'add_and_continue': 'Add &amp; continue',
                'discard_and_continue': 'Discard &amp; continue',
                'save_and_continue': 'Save &amp; continue',
                'apply': 'Apply',
                'ready': 'Ready',
                'send': 'Send',
            },
            'page_flags': {
                'home': 'Homepage',
                'register': 'Register',
                'page_not_found': 'Page not found',
                'payment_failed': 'Payment: failed',
                'payment_in_progress': 'Payment: in progress',
            },
            'access_levels': {
                'public': 'Anybody',
                'login': 'Logged in',
                'logout': 'Logged out',
                'hidden': 'Nobody',
                'public_description': 'Anybody can view this page',
                'login_description': 'Only users can view this page',
                'logout_description': 'Only non-users can view this page',
                'hidden_description': 'Nobody van view this page'
            },
            'account_types': {
                'contact': 'Person',
                'organisation': 'Organisation',
                'team': 'Team'
            },
            'genders': {
                'm': 'Male',
                'f': 'Female'
            },
            'gifts': {
                'privacy': {
                    'no_contact': 'Do not share my contact information with the participant.',
                    'hide_amount': 'Do not publish my donation amount on the website.',
                    'hide_name': 'Do not publish my name on the website.'
                }
            },
            'action_campaign_overview_display_options': {
                'image': 'Cover image',
                'title': 'Title',
                'gift_amount': 'Funds raised',
                'target': 'Fundraising target',
                'end_date': 'End date',
                'action_campaign': 'Campaign',
                'action_project': 'Project',
                'meta': 'Meta',
                'action_campaign_type': 'Campaign type',
                'group_labels': 'Group labels',
                'cause': 'Cause'
            },
            'action_campaign_overview_sort_options': {
                'title': 'Title',
                'gift_amount': 'Funds raised',
                'date_created': 'Date created',
                'end_date': 'End date',
                'random': 'Random'
            },
            'action_campaign_overview_sort_directions': {
                'asc': {
                    'title': 'A-Z',
                    'gift_amount': 'Low to high',
                    'date_created': 'Oldest first',
                    'end_date': 'Oldest first'
                },
                'desc': {
                    'title': 'Z-A',
                    'gift_amount': 'High to low',
                    'date_created': 'Newest first',
                    'end_date': 'Newest first'
                }
            },
            'action_campaign_overview_layout_options': {
                'full': 'Full overview',
                'list': 'Leaderboard'
            },
            'formats': {
                'camt053_xml': 'CAMT.053 XML'
            },
            'operators': {
                '=': 'equals',
                '!=': 'does not equal',
                '>': 'is greater than',
                '>=': 'is greater than or equal to',
                '<': 'is less than',
                '<=': 'is less than or equal to',
                'and': 'matches all of',
                'any': 'matches any of',
                'eq_interval': 'equals (interval)',
                'neq_interval': 'does not equal (interval)',
                'gt_interval': 'is more than (interval)',
                'gte_interval': 'is more than or equal to (interval)',
                'lt_interval': 'is less than (interval)',
                'lte_interval': 'is less than or equal to (interval)',
                'today': 'is today',
                'today_without_year': 'is today (any year)',
                'empty': 'is empty',
                'not_empty': 'is not empty',
                'in': 'is any of',
                'not_in': 'is none of',
                'starts_with': 'starts with'
            },
            'interval_directions': {
                'past': 'in past',
                'future': 'in future'
            },
            'interval_types': {
                'days': 'days',
                'weeks': 'weeks',
                'months': 'months',
                'years': 'years'
            },
            'languages': {
                'dutch': 'Dutch',
                'english': 'English',
                'german': 'German',
                'french': 'French',
                'spanish': 'Spanish',
                'italian': 'Italian',
                'swedish': 'Swedish'
            },
            'pagination': {
                'stats': '{{ (from == 1 || from > total) && total <= to ? total + \' result\' + (total != 1 ? \'s\' : \'\') : (total ? (\'Showing results \' + (from | number)  + \' to \' + ((total < to ? total : to) | number) + \' out of \' + (total | number)) : \'\') }}'
            },
            'sequence_types': {
                'FNAL': 'Final',
                'FRST': 'First',
                'OOFF': 'One-off',
                'RCUR': 'Recurring'
            },
            'order_statuses': {
                'active': 'Active',
                'cancelled': 'Cancelled',
                'finished': 'Finished',
                'failed': 'Failed'
            },
            'recurring_interval': 'Per ' +
                '{{ years > 1 || (years && (months || days)) ? years + \' \' : \'\' }}{{ years > 1 ? \'general.years\' : (years == 1 ? \'general.year\' : \'\') | translate }}' +
                '{{ years && months ? \' and \' : (years && (months || days) ? \' \' : \'\') }}' +
                '{{ months > 1 || (months && (years || days)) ? months + \' \' : \'\' }}{{ months > 1 ? \'general.months\' : (months == 1 ? \'general.month\' : \'\') | translate }}' +
                '{{ (years || months) && days ? \' and \' : (months && days ? \' \' : \'\') }}' +
                '{{ days > 1 || (days && (years || months)) ? days + \' \' : \'\' }}{{ days > 1 ? \'general.days\' : (days == 1 ? \'general.day\' : \'\') | translate }}',
            'sites': {
                'corporate': 'Corporate',
                '2016': '2016',
                '2017': '2017',
                '2017_english': '2017 (English)',
                'nymarathon': 'NY Marathon',
                'edizione_olandese_2017': 'Edizione Olandese (2017)',
                'mud_masters': 'Mud Masters',
                'ambassadors_club': 'Ambassadors Club',
            },
            'sepa_reasons': {
                'AC01': 'Account number incorrect (invalid IBAN)',
                'AC04': 'Account closed',
                'AC06': 'Account blocked',
                'AG01': 'Direct debit forbidden on this account for regulatory reasons',
                'AG02': 'Operation/transaction code incorrect, invalid file format',
                'AM04': 'Insufficient funds',
                'AM05': 'Duplicate collection',
                'BE04': 'Missing creditor address',
                'MD01': 'No mandate',
                'MD02': 'Mandate data missing or incorrect',
                'FF01': 'Invalid file format',
                'MD06': 'Refund request by account holder',
                'MD07': 'Account holder deceased',
                'MS02': 'Refusal by debtor',
                'MS03': 'Reason not specified',
                'RC01': 'Bank identifier incorrect (invalid BIC)',
                'TM01': 'Cut-off time',
                'SL01': 'Specific service offered by debtor bank',
                'FOCR': 'Return due to a recall',
                'DUPL': 'Duplicate payment',
                'TECH': 'Technical error',
                'FRAD': 'Fraud',
                'AGNT': 'Incorrect agent',
                'CURR': 'Incorrect currency',
                'CUST': 'Recall by customer',
                'CUTA': 'Recall due to investigation request',
                'UPAY': 'Undue payment',
                'BE05': 'Unrecognised initiating party',
                'AC13': 'Invalid debtor account type',
                'FF05': 'Invalid local instrument code',
                'DNOR': 'Debtor bank is not registered',
                'CNOR': 'Creditor bank is not registered',
                'PY01': 'Unknown BIC in routing table'
            },
            'bank_statement_match_types': {
                'ignored_payment': 'Ignored',
                'matched_payment': 'Matched',
                'referenced_payment': 'Referenced',
                'sdd_batch_payment': 'SDD payment',
                'sdd_batch_payment_untracked': 'Unknown SDD payment',
                'sdd_reversal': 'SDD reversal',
                'sdd_reversal_untracked': 'Untracked SDD reversal',
                'skip_negative_amount': 'Expense',
                'skip_no_iban': 'Bank',
                'unknown_entry': 'Unknown',
                'unmatched_payment': 'Unmatched'
            },
            'duplicate_match_types': {
                'title': 'Full name',
                'email': 'Email address',
                'address': 'Address',
                'iban': 'IBAN',
                'personal': 'Personal details',
            },
            'discount_code_types': {
                'absolute': 'Absolute',
                'percentage': 'Percentage'
            },
            'module_types': {
                'action_campaign_overview': 'Campaign(er) overview',
                'list': 'List',
                'card': 'Card',
                'carousel': 'Carousel',
                'image': 'Image',
                'line': 'Line',
                'button': 'Button',
                'countdown': 'Countdown',
                'gallery': 'Gallery',
                'share': 'Share',
                'content': 'Content block',
                'html': 'HTML block',
                'form': 'Form',
                'news': 'News',
                'news_feed': 'News feed',
                'video': 'Video',
                'faq': 'FAQ',
                'slider': 'Slider',
            },
            'module_type_descriptions' : {
                'action_campaign_overview': 'Showcase your campaigns, participants and teams. You can customize the layout and ordering and select the information to display.',
                'list': 'A horizontally or vertically aligned list of items containing a text summary and icon. The items can optionally link to pages.',
                'image': 'Upload an image and optionally display text on top of the image. The image can also link to other pages.',
                'line': 'Divide your content using a colored horizontal line.',
                'card': 'Display your content in the shape of a card, with image, link and button.',
                'carousel': 'Display a number of images and continuously scroll to the next ones.',
                'button': 'Link to other pages using a stylish button.',
                'countdown': 'Count down the days and seconds towards an important moment.',
                'gallery': 'Create a beautiful gallery by uploading your photo\'s and selecting a layout. Visitors can browse through the gallery by clicking on it.',
                'share': 'Show buttons to share the current page on social media, such as WhatsApp, Twitter and Instagram.',
                'content': 'Create content containing text and images using a convenient editor.',
                'html': 'For the tech-savvy: create your own module using, for example, HTML and JavaScript code.',
                'form': 'Display one of the forms you have created through One Community.',
                'video': 'Embed a video by providing a YouTube or Vimeo link.',
                'faq': 'Enter common questions and their answers and display them to your visitors.',
                'news': 'Start a news section. You can add news posts with an image/video and publication date after adding the module.',
                'news_feed': 'Display a filterable list or overview containing news posts from multiple news modules.',
                'slider': 'Upload images and optionally display text on top of the image. Show one image at a item and slide to the next one after a few seconds.',
            },
            'news_feed_layouts': {
                'list': 'List',
                'columns': 'Columns',
            },
            'post_statuses': {
                'hide': 'Always hide',
                'after_publication': 'Show after publication date only',
                'show': 'Always show'
            },
            'page_nav_link_visibilities': {
                'all': 'Everybody',
                'user': 'Users',
                'guest': 'Guests'
            },
            'brand': {
                'default': 'Default',
                'primary': 'Primary',
                'secondary': 'Secondary',
                'tertiary': 'Tertiary',
                'quaternary': 'Quaternary',
                'quinary': 'Quinary',
                'gray': 'Gray',
                'white': 'White',
                'black': 'Black',
                'transparent': 'Transparent'
            },
            'row_classes': {
                'full-width': 'Full width',
                'no-spacing': 'No spacing',
            },
            'form_field_types': {
                'account': 'Contact',
                'account.city': 'Contact › City',
                'account.postal_city': 'Contact › City (postal)',
                'account.country': 'Contact › Country',
                'account.postal_country': 'Contact › Country (postal)',
                'account.image': 'Contact › Image',
                'account.phone_work': 'Contact › Phone (work)',
                'account.date_of_birth': 'Contact › Date of birth',
                'account.infix': 'Contact › Infix',
                'account.street': 'Contact › Street',
                'account.postal_street': 'Contact › Street (postal)',
                'account.email': 'Contact › Email',
                'account.email_username': 'Contact › Email (with username fallback)',
                'account.secondary_email': 'Contact › Secondary email',
                'account.initials': 'Contact › Initials',
                'account.title': 'Contact › Title',
                'account.first_name': 'Contact › First name',
                'account.last_name': 'Contact › Last name',
                'account.unsubscribe_from_mails': 'Contact › Mailings opt-out',
                'account.subscribe_to_mails': 'Contact › Mailings opt-in',
                'account.gender': 'Contact › Gender',
                'account.password': 'Contact › Password',
                'account.zip_code': 'Contact › ZIP code',
                'account.postal_zip_code': 'Contact › ZIP code (postal)',
                'account.house_number_addition': 'Contact › House number add.',
                'account.postal_house_number_addition': 'Contact › House number add. (postal)',
                'account.phone_home': 'Contact › Phone (home)',
                'account.house_number': 'Contact › House number',
                'account.postal_house_number': 'Contact › House number (postal)',
                'account.phone_private': 'Contact › Phone (private)',
                'account.phone_emergency': 'Contact › Phone (emergency)',
                'account.note': 'Contact › Note',
                'account.variables.tshirt_size': 'Contact › T-shirt size',
                'discount_code': 'Order › Discount code',
                'generic_integer': 'Number',
                'gift.message': 'Gift › Message',
                'gift.privacy': 'Gift › Privacy',
                'gift.destination': 'Gift › Destination',
                'post': 'Post',
                'account_type': 'Contact › Type',
                'form_entry': 'Sub form',
                'file': 'Contact › Attachment',
                'generic_money': 'Money',
                'group': 'Contact › Group',
                'sub_group': 'Contact › Sub group',
                'order.reference': 'Order › Reference',
                'generic_date': 'Date',
                'generic_string': 'Short text',
                'ideal_bank': 'Order › iDEAL bank',
                'idin_bank': 'Order › iDIN bank',
                'purchase': 'Order › Product',
                'bank_account': 'Order › IBAN',
                'generic_email': 'Email',
                'generic_text': 'Long text',
                'payment_method': 'Order › Payment method',
                'action_campaign': 'Campaign',
                'action_campaign.child.image': 'Campaigner › Image',
                'action_campaign.child.description': 'Campaigner › Description',
                'action_campaign.child.target': 'Campaigner › Target',
                'action_campaign.child.share': 'Campaigner › Share',
                'action_campaign.child.active': 'Campaigner › Active',
                'action_campaign.description': 'Campaign › Description',
                'action_campaign.end_date': 'Campaign › End date',
                'action_campaign.image': 'Campaign › Image',
                'action_campaign.type': 'Campaign › Type',
                'action_campaign.target': 'Campaign › Target',
                'action_campaign.title': 'Campaign › Title',
                'action_campaign.active': 'Campaign › Active',
                'action_campaign.cause_title': 'Campaign › Cause title',
                'action_campaign.cause_iban': 'Campaign › Cause IBAN',
                'action_project': 'Project',
                'post.content': 'Post › Content',
                'post.image': 'Post › Image',
                'post.title': 'Post › Title',
                'post.video_link': 'Post › Video link',
                'language': 'Language'
            },
            'form_field_type_descriptions': {
                'account': 'Let the end-user select a contact in your database.',
                'account.city': 'Let the end-user enter their city name.',
                'account.postal_city': 'Let the end-user enter their postal city name.',
                'account.country': 'Let the end-user enter their country name.',
                'account.postal_country': 'Let the end-user enter their postal country name.',
                'account.image': 'Let the end-user upload an image.',
                'account.phone_work': 'Let the end-user enter their phone number (work).',
                'account.date_of_birth': 'Let the end-user enter their date of birth.',
                'account.infix': 'Let the end-user enter their infix (prefix of last name).',
                'account.street': 'Let the end-user enter their street name.',
                'account.postal_street': 'Let the end-user enter their postal street name.',
                'account.email': 'Let the end-user enter their email address.',
                'account.email_username': 'Let the end-user enter a unique email address. In case it has already been taken, let them choose a unique username.',
                'account.secondary_email': 'Let the end-user enter a secondary email address.',
                'account.initials': 'Let the end-user enter their initials.',
                'account.title': 'Let the end-user enter their company/organisation name.',
                'account.first_name': 'Let the end-user enter their first name.',
                'account.last_name': 'Let the end-user enter their last name.',
                'account.unsubscribe_from_mails': 'Let the end-user opt out of mailings.',
                'account.subscribe_to_mails': 'Let the end-user opt in to mailings',
                'account.gender': 'Let the end-user enter their gender.',
                'account.password': 'Let the end-user enter their password.',
                'account.zip_code': 'Let the end-user enter their ZIP code.',
                'account.postal_zip_code': 'Let the end-user enter their postal ZIP code.',
                'account.house_number_addition': 'Let the end-user enter their house number (addition).',
                'account.postal_house_number_addition': 'Let the end-user enter their postal house number (addition).',
                'account.phone_home': 'Let the end-user enter their phone number (home).',
                'account.house_number': 'Let the end-user enter their house number.',
                'account.postal_house_number': 'Let the end-user enter their postal house number.',
                'account.phone_private': 'Let the end-user enter their phone number (private).',
                'account.phone_emergency': 'Let the end-user enter their phone number (emergency).',
                'account.note': 'Let the end-user enter a note that will be added to their file.',
                'account.variables.tshirt_size': 'Let the end-user enter their t-shirt size.',
                'discount_code': 'Let the end-user enter a discount code.',
                'generic_integer': 'Let the end-user enter a whole number.',
                'gift.message': 'Let the end-user enter a message that will be displayed on the page of the recipient of the gift.',
                'gift.privacy': 'Let the end-user choose if they want to publish their information on the website.',
                'gift.destination': 'Let the end-user choose a destination project, campaign or participant for their gift.',
                'account_type': 'Let the end-user choose a type (person, team, or organisation).',
                'form_entry': 'Let the end-user enter all the fields of a sub form.',
                'file': 'Let the end-user upload an attachment.',
                'generic_money': 'Let the end-user enter a money amount.',
                'group': 'Let the end-user select a group that they will become a member of.',
                'sub_group': 'Let the end-user select any sub group of a certain group that you define.',
                'order.reference': 'Let the end-user enter an order reference/number.',
                'generic_date': 'Let the end-user enter a date.',
                'generic_string': 'Let the end-user enter a short sentence.',
                'ideal_bank': 'Let the end-user choose a bank to complete the iDEAL payment.',
                'idin_bank': 'Let the end-user choose a bank to complete the iDIN verification.',
                'purchase': 'Offer a product to the end-user.',
                'bank_account': 'Let the user enter their IBAN.',
                'generic_email': 'Let the end-user enter any email address.',
                'generic_text': 'Let the end-user enter a paragraph of text.',
                'payment_method': 'Let the end-user choose a payment method.',
                'action_campaign': 'Let the end-user join a campaign.',
                'action_campaign.child.image': 'Let the end-user upload a personal cover photo.',
                'action_campaign.child.description': 'Let the end-user enter a personal motivation.',
                'action_campaign.child.target': 'Let the end-user specify a personal fundraising target.',
                'action_campaign.child.share': 'Let the end-user choose if they want to share in direct gifts to their team campaign.',
                'action_campaign.child.active': 'Let the end-user choose if their personal page should be visible on the website.',
                'action_campaign.description': 'Let the end-user enter a motivation for their campaign.',
                'action_campaign.end_date': 'Let the end-user enter an end date for their campaign.',
                'action_campaign.image': 'Let the end-user upload a cover photo for their campaign.',
                'action_campaign.type': 'Let the end-user choose a campaign type (open, team, or individual)',
                'action_campaign.target': 'Let the end-user specify a fundraising target for their campaign.',
                'action_campaign.title': 'Let the end-user enter a campaign title.',
                'action_campaign.active': 'Let the end-user choose if their campaign page should be visible on the website.',
                'action_campaign.cause_title': 'Let the end-user enter a cause for who they will be raising money.',
                'action_campaign.cause_iban': 'Let the end-user enter a cause its IBAN to where they want the raised funds to be transferred.',
                'action_project': 'Let the end-user choose a project for their campaign.',
                'post.content': '',
                'post.image': '',
                'post.title': '',
                'post.video_link': '',
                'language': 'Let the end-user choose their language.'
            },
            'navbar': {
                'content': 'Website',
                'crm': 'Community',
                'events': 'Events',
                'crowdfunding': 'Crowdfunding',
                'email': 'Email',
                'sales': 'Sales',
                'finance': 'Finance',
                'pages': 'Pages',
                'page_navs': 'Navigation',
                'modules': 'Content',
                'files': 'Files',
                'page_blocks': 'Page blocks',
                'pdf_templates': 'PDF templates',
                'site_settings': 'Settings',
                'contacts': 'Contacts',
                'interactions': 'Interactions',
                'groups': 'Groups',
                'segments': 'Segments',
                'forms': 'Forms',
                'campaigns': 'Campaigns',
                'transactional_mail': 'Transactional mail',
                'templates': 'Templates',
                'senders': 'Senders',
                'dashboard': 'Dashboard',
                'orders': 'Orders',
                'gifts': 'Gifts',
                'products': 'Products',
                'discount_codes': 'Discounts',
                'transactions': 'Transactions',
                'direct_debit': 'Direct debit',
                'bank_transfer': 'Bank transfer',
                'reversals': 'Reversals',
                'import': 'Import',
                'bank_statements': 'Bank statements',
                'projects': 'Projects',
                'campaigns': 'Campaigns',
                'gifts': 'Gifts'
            },
            'html_templates': {
                'placeholder_types': {
                    'text': 'Rich text',
                    'plain': 'Plain text',
                    'image': 'Image',
                }
            },
            'mail_templates': {
                'placeholder_types': {
                    'text': 'Rich text',
                    'plain': 'Plain text',
                    'image': 'Image',
                    'html': 'HTML'
                },
                'placeholder_titles': {
                    'preheader': 'Preheader',
                    'header': 'Header',
                    'body': 'Body',
                    'footer': 'Footer'
                },
                'css_variables': {
                    'font_family': 'Font family',
                    'font_size_desktop': 'Font size (desktop)',
                    'font_size_mobile': 'Font size (mobile)',
                    'text_color': 'Text color',
                    'link_color': 'Link color',
                    'title_font_family': 'Title font family',
                    'title_color': 'Title color',
                    'h1_size': 'H1 size',
                    'h2_size': 'H2 size',
                    'h3_size': 'H3 size',
                    'footer_color': 'Footer text color',
                    'body_background': 'Body background',
                    'content_background': 'Content background'
                }
            },
            'variables': {
                'site': {
                    'url': 'Website URL',
                },
                'account': {
                    'first_name': 'First name',
                    'full_name': 'Full name',
                },
                'sender': {
                    'signature': 'Signature'
                },
                'body': 'Body',
                'unsubscribe_url': 'Unsubscribe URL',
                'user_nav': 'User nav'
            },
            'auditor': {
                'created': '{{ hasActor ? "created" : "Created" }}',
                'changed': '{{ hasActor ? "changed" : "Changed" }}',
                'attached': '{{ hasActor ? "attached" : "Attached" }}',
                'detached': '{{ hasActor ? "detached" : "Detached" }}',
                'set': '{{ hasActor ? "set" : "Set" }}',
                'unset': '{{ hasActor ? "unset" : "Unset" }}',
                'deleted': '{{ hasActor ? "deleted" : "Deleted" }}',
                'previous': 'Previous',
                'new': 'New'
            },
            'notifications': {
                'assigned_task': 'Receive an e-mail when someone assigns a to-do to me.'
            },
            'social_media': {
                'facebook': 'Facebook',
                'twitter': 'Twitter',
                'instagram': 'Instagram',
                'linkedin': 'LinkedIn',
                'youtube': 'YouTube',
                'vimeo': 'Vimeo',
            }
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy(null);
    }
})(angular);
